//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param password (optional) 
     * @param rememberMe (optional) 
     * @param captchaText (optional) 
     * @param captchaToken (optional) 
     * @param captchaInputText (optional) 
     * @return OK
     */
    login(userName: string | undefined, password: string | undefined, rememberMe: boolean | undefined, captchaText: string | undefined, captchaToken: string | undefined, captchaInputText: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName === null || userName === undefined)
            throw new Error("The parameter 'userName' cannot be null.");
        else
            content_.append("UserName", userName.toString());
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (rememberMe === null || rememberMe === undefined)
            throw new Error("The parameter 'rememberMe' cannot be null.");
        else
            content_.append("RememberMe", rememberMe.toString());
        if (captchaText === null || captchaText === undefined)
            throw new Error("The parameter 'captchaText' cannot be null.");
        else
            content_.append("CaptchaText", captchaText.toString());
        if (captchaToken === null || captchaToken === undefined)
            throw new Error("The parameter 'captchaToken' cannot be null.");
        else
            content_.append("CaptchaToken", captchaToken.toString());
        if (captchaInputText === null || captchaInputText === undefined)
            throw new Error("The parameter 'captchaInputText' cannot be null.");
        else
            content_.append("CaptchaInputText", captchaInputText.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    captcha( cancelToken?: CancelToken): Promise<DNTCaptchaApiResponse> {
        let url_ = this.baseUrl + "/api/v1/account/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaptcha(_response);
        });
    }

    protected processCaptcha(response: AxiosResponse): Promise<DNTCaptchaApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DNTCaptchaApiResponse.fromJS(resultData200);
            return Promise.resolve<DNTCaptchaApiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DNTCaptchaApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    refreshToken( cancelToken?: CancelToken): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRefreshTokenResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginWith2fa(body: LoginWith2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-with-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWith2fa(_response);
        });
    }

    protected processLoginWith2fa(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    userInfo( cancelToken?: CancelToken): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserInfo(_response);
        });
    }

    protected processUserInfo(response: AxiosResponse): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve<UserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    setup2fa( cancelToken?: CancelToken): Promise<Setup2FADto> {
        let url_ = this.baseUrl + "/api/v1/account/setup-2fa";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetup2fa(_response);
        });
    }

    protected processSetup2fa(response: AxiosResponse): Promise<Setup2FADto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Setup2FADto.fromJS(resultData200);
            return Promise.resolve<Setup2FADto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Setup2FADto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    enable2fa(body: Enable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/enable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable2fa(_response);
        });
    }

    protected processEnable2fa(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    get2faStatus( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/get-2fa-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2faStatus(_response);
        });
    }

    protected processGet2faStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disable2fa(body: Disable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/disable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisable2fa(_response);
        });
    }

    protected processDisable2fa(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAvatar(body: UpdateAvatarDto | undefined, cancelToken?: CancelToken): Promise<UpdateAvatarDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAvatar(_response);
        });
    }

    protected processUpdateAvatar(response: AxiosResponse): Promise<UpdateAvatarDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateAvatarDto.fromJS(resultData200);
            return Promise.resolve<UpdateAvatarDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateAvatarDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInfo(body: UpdateInfoDto | undefined, cancelToken?: CancelToken): Promise<UpdateInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<UpdateInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoDto.fromJS(resultData200);
            return Promise.resolve<UpdateInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    validate(token: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/token/validate?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkSession( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSession(_response);
        });
    }

    protected processCheckSession(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userGetList(body: UserGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetList(_response);
        });
    }

    protected processUserGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfRegisterDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetById(_response);
        });
    }

    protected processUserGetById(response: AxiosResponse): Promise<ApiResponse_1OfRegisterDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRegisterDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRegisterDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRegisterDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    userGetPermission(userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-permission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetPermission(_response);
        });
    }

    protected processUserGetPermission(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleModuleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleModuleDto>(null as any);
    }

    /**
     * @param isRessPass (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdate(isRessPass: boolean | undefined, body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/update?";
        if (isRessPass === null)
            throw new Error("The parameter 'isRessPass' cannot be null.");
        else if (isRessPass !== undefined)
            url_ += "isRessPass=" + encodeURIComponent("" + isRessPass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdate(_response);
        });
    }

    protected processUserUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdatePermisson(userId: number | undefined, body: RoleModuleDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-permission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdatePermisson(_response);
        });
    }

    protected processUserUpdatePermisson(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userUpdateEmail(body: ChangeEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdateEmail(_response);
        });
    }

    protected processUserUpdateEmail(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    accountDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountDelete(_response);
        });
    }

    protected processAccountDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    userGetListByType(type: UserTypeEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list-by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetListByType(_response);
        });
    }

    protected processUserGetListByType(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserWithSimpleInfoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(null as any);
    }

    /**
     * @param formFile (optional) 
     * @return OK
     */
    accountImport(formFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountImport(_response);
        });
    }

    protected processAccountImport(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    account( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccount(_response);
        });
    }

    protected processAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addActivityLog(body: ActivityLogEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfActivityLogEntity> {
        let url_ = this.baseUrl + "/api/v1/activity-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddActivityLog(_response);
        });
    }

    protected processAddActivityLog(response: AxiosResponse): Promise<ApiResponse_1OfActivityLogEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActivityLogEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActivityLogEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActivityLogEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activityLogGetList(body: GetListLogQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        let url_ = this.baseUrl + "/api/v1/activity-log/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityLogGetList(_response);
        });
    }

    protected processActivityLogGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListActivityLogDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh/refresh?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshGET(_response);
        });
    }

    protected processRefreshGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh/refresh?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshPOST(_response);
        });
    }

    protected processRefreshPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show/show?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowGET(_response);
        });
    }

    protected processShowGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show/show?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowPOST(_response);
        });
    }

    protected processShowPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    categoryGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetById(_response);
        });
    }

    protected processCategoryGetById(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCategory(body: CategoryEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCategory(_response);
        });
    }

    protected processSaveCategory(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryGetList(body: CategoryGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        let url_ = this.baseUrl + "/api/v1/category/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetList(_response);
        });
    }

    protected processCategoryGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfCategoryListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(null as any);
    }

    /**
     * @return OK
     */
    categoryDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/category/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryDelete(_response);
        });
    }

    protected processCategoryDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param excelFile (optional) 
     * @return OK
     */
    categoryImportFromExcel(excelFile: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryImportResult> {
        let url_ = this.baseUrl + "/api/v1/category/import-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile === null || excelFile === undefined)
            throw new Error("The parameter 'excelFile' cannot be null.");
        else
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryImportFromExcel(_response);
        });
    }

    protected processCategoryImportFromExcel(response: AxiosResponse): Promise<ApiResponse_1OfCategoryImportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryImportResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryImportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryImportResult>(null as any);
    }

    /**
     * @param folderPath (optional) 
     * @return OK
     */
    categoryImportFromFolder(folderPath: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryImportFromFolderResult> {
        let url_ = this.baseUrl + "/api/v1/category/import-folder?";
        if (folderPath === null)
            throw new Error("The parameter 'folderPath' cannot be null.");
        else if (folderPath !== undefined)
            url_ += "FolderPath=" + encodeURIComponent("" + folderPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryImportFromFolder(_response);
        });
    }

    protected processCategoryImportFromFolder(response: AxiosResponse): Promise<ApiResponse_1OfCategoryImportFromFolderResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryImportFromFolderResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryImportFromFolderResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryImportFromFolderResult>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listChatGroupOfUser(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/list-chat-group-of-user?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListChatGroupOfUser(_response);
        });
    }

    protected processListChatGroupOfUser(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createChatGroup(body: CreateChatGroupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroup(_response);
        });
    }

    protected processCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @return OK
     */
    getDetailChatGroup(chatGroupId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupDetailDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-detail-chat-group?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailChatGroup(_response);
        });
    }

    protected processGetDetailChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param skipSize (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getListMessageByChatGroupId(chatGroupId: number | undefined, skipSize: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-message-by-groupid?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        if (skipSize === null)
            throw new Error("The parameter 'skipSize' cannot be null.");
        else if (skipSize !== undefined)
            url_ += "skipSize=" + encodeURIComponent("" + skipSize) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListMessageByChatGroupId(_response);
        });
    }

    protected processGetListMessageByChatGroupId(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListUserForCreateChatGroup(body: GetListUserForCreateChatGroupQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-user-for-create-chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListUserForCreateChatGroup(_response);
        });
    }

    protected processGetListUserForCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    createChatGroupOfDocument(documentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group-of-document?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroupOfDocument(_response);
        });
    }

    protected processCreateChatGroupOfDocument(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addUserToChatGroup(chatGroupId: number | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/chat/add-user-to-chat-group?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToChatGroup(_response);
        });
    }

    protected processAddUserToChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    countMessageUnRead( cancelToken?: CancelToken): Promise<ApiResponse_1OfInt32> {
        let url_ = this.baseUrl + "/api/v1/chat/count-message-un-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountMessageUnRead(_response);
        });
    }

    protected processCountMessageUnRead(response: AxiosResponse): Promise<ApiResponse_1OfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt32.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt32>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveContract(body: ContractFormDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfContractEntity> {
        let url_ = this.baseUrl + "/api/v1/contract/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveContract(_response);
        });
    }

    protected processSaveContract(response: AxiosResponse): Promise<ApiResponse_1OfContractEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContractEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContractEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContractEntity>(null as any);
    }

    /**
     * @param filePath (optional) 
     * @return OK
     */
    addContract(filePath: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/contract/add?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddContract(_response);
        });
    }

    protected processAddContract(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @return OK
     */
    contractGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfContractEntity> {
        let url_ = this.baseUrl + "/api/v1/contract/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractGetById(_response);
        });
    }

    protected processContractGetById(response: AxiosResponse): Promise<ApiResponse_1OfContractEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContractEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContractEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContractEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contractGetList(body: ContractGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfContractListDto> {
        let url_ = this.baseUrl + "/api/v1/contract/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractGetList(_response);
        });
    }

    protected processContractGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfContractListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfContractListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfContractListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfContractListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contractGetListCompany(body: ContractCompanyQueryDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfContractListDto> {
        let url_ = this.baseUrl + "/api/v1/contract/list-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractGetListCompany(_response);
        });
    }

    protected processContractGetListCompany(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfContractListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfContractListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfContractListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfContractListDto>(null as any);
    }

    /**
     * @return OK
     */
    contractDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/contract/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractDelete(_response);
        });
    }

    protected processContractDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    contractCount( cancelToken?: CancelToken): Promise<ApiResponse_1OfContractCountDto> {
        let url_ = this.baseUrl + "/api/v1/contract/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractCount(_response);
        });
    }

    protected processContractCount(response: AxiosResponse): Promise<ApiResponse_1OfContractCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContractCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContractCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContractCountDto>(null as any);
    }

    /**
     * @return OK
     */
    contractCountCompany( cancelToken?: CancelToken): Promise<ApiResponse_1OfContractCountCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/contract/count-company";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractCountCompany(_response);
        });
    }

    protected processContractCountCompany(response: AxiosResponse): Promise<ApiResponse_1OfContractCountCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContractCountCompanyDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContractCountCompanyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContractCountCompanyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    contractGetCustomerById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfContractCustomerDto> {
        let url_ = this.baseUrl + "/api/v1/contract/get-customer-info?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContractGetCustomerById(_response);
        });
    }

    protected processContractGetCustomerById(response: AxiosResponse): Promise<ApiResponse_1OfContractCustomerDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfContractCustomerDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfContractCustomerDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfContractCustomerDto>(null as any);
    }

    /**
     * @return OK
     */
    getContractSchemaConfig( cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/contract/schema-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractSchemaConfig(_response);
        });
    }

    protected processGetContractSchemaConfig(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveDocument(body: DocumentEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentEntity> {
        let url_ = this.baseUrl + "/api/v1/document/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDocument(_response);
        });
    }

    protected processSaveDocument(response: AxiosResponse): Promise<ApiResponse_1OfDocumentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentEntity>(null as any);
    }

    /**
     * @param contractCode (optional) 
     * @param benefitGroup (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendDocument(contractCode: string | undefined, benefitGroup: number | undefined, body: DocumentFileSendDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentEntity> {
        let url_ = this.baseUrl + "/api/v1/document/send?";
        if (contractCode === null)
            throw new Error("The parameter 'contractCode' cannot be null.");
        else if (contractCode !== undefined)
            url_ += "contractCode=" + encodeURIComponent("" + contractCode) + "&";
        if (benefitGroup === null)
            throw new Error("The parameter 'benefitGroup' cannot be null.");
        else if (benefitGroup !== undefined)
            url_ += "benefitGroup=" + encodeURIComponent("" + benefitGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDocument(_response);
        });
    }

    protected processSendDocument(response: AxiosResponse): Promise<ApiResponse_1OfDocumentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    closeDocument(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/close?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseDocument(_response);
        });
    }

    protected processCloseDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param rejectionType (optional) 
     * @param note (optional) 
     * @return OK
     */
    refuseDocument(id: number | undefined, rejectionType: number | undefined, note: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/refuse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (rejectionType === null)
            throw new Error("The parameter 'rejectionType' cannot be null.");
        else if (rejectionType !== undefined)
            url_ += "rejectionType=" + encodeURIComponent("" + rejectionType) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefuseDocument(_response);
        });
    }

    protected processRefuseDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    approvedDeleteIdDocument(id: number | undefined, body: DocumentFilePartEntity[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/delete-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovedDeleteIdDocument(_response);
        });
    }

    protected processApprovedDeleteIdDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    approvedExtractInfoDocument(body: DocumentEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/extract-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovedExtractInfoDocument(_response);
        });
    }

    protected processApprovedExtractInfoDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentApprovedMedical(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/approved-medical?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentApprovedMedical(_response);
        });
    }

    protected processDocumentApprovedMedical(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentApproved(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/approved?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentApproved(_response);
        });
    }

    protected processDocumentApproved(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentSendLeader(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/send-leader?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentSendLeader(_response);
        });
    }

    protected processDocumentSendLeader(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentSendCompany(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/send-company?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentSendCompany(_response);
        });
    }

    protected processDocumentSendCompany(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    documentAddFile(id: number | undefined, body: DocumentFileSendDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/add-fille?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentAddFile(_response);
        });
    }

    protected processDocumentAddFile(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param missingFiles (optional) 
     * @return OK
     */
    documentRequestAddFile(id: number | undefined, missingFiles: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/request-add-fille?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (missingFiles === null)
            throw new Error("The parameter 'missingFiles' cannot be null.");
        else if (missingFiles !== undefined)
            url_ += "missingFiles=" + encodeURIComponent("" + missingFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentRequestAddFile(_response);
        });
    }

    protected processDocumentRequestAddFile(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @return OK
     */
    documentTransfer(id: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/transfer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentTransfer(_response);
        });
    }

    protected processDocumentTransfer(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentCancel(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/cancel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentCancel(_response);
        });
    }

    protected processDocumentCancel(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    documentGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentEntity> {
        let url_ = this.baseUrl + "/api/v1/document/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetById(_response);
        });
    }

    protected processDocumentGetById(response: AxiosResponse): Promise<ApiResponse_1OfDocumentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentGetDetail(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/document/detail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetDetail(_response);
        });
    }

    protected processDocumentGetDetail(response: AxiosResponse): Promise<ApiResponse_1OfDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDocumentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentGetList(body: DocumentGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfDocumentListDto> {
        let url_ = this.baseUrl + "/api/v1/document/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetList(_response);
        });
    }

    protected processDocumentGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfDocumentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfDocumentListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfDocumentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfDocumentListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentGetCount(body: DocumentCountQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDictionary_2OfInt32AndInt32> {
        let url_ = this.baseUrl + "/api/v1/document/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetCount(_response);
        });
    }

    protected processDocumentGetCount(response: AxiosResponse): Promise<ApiResponse_1OfDictionary_2OfInt32AndInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDictionary_2OfInt32AndInt32.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDictionary_2OfInt32AndInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDictionary_2OfInt32AndInt32>(null as any);
    }

    /**
     * @return OK
     */
    documentDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentDelete(_response);
        });
    }

    protected processDocumentDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDocumentListShortDto> {
        let url_ = this.baseUrl + "/api/v1/document/get-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetByIds(_response);
        });
    }

    protected processDocumentGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDocumentListShortDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDocumentListShortDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDocumentListShortDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDocumentListShortDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentMaxPayment(body: DocumentMaxPaymentQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfNullable_1OfDecimal> {
        let url_ = this.baseUrl + "/api/v1/document/get-max-payement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentMaxPayment(_response);
        });
    }

    protected processDocumentMaxPayment(response: AxiosResponse): Promise<ApiResponse_1OfNullable_1OfDecimal> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfNullable_1OfDecimal.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfNullable_1OfDecimal>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfNullable_1OfDecimal>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isFull (optional) 
     * @return OK
     */
    documentDashboardSummary(fromDate: Date | undefined, toDate: Date | undefined, isFull: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDashboardSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/document/dashboard-summary?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isFull === null)
            throw new Error("The parameter 'isFull' cannot be null.");
        else if (isFull !== undefined)
            url_ += "isFull=" + encodeURIComponent("" + isFull) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentDashboardSummary(_response);
        });
    }

    protected processDocumentDashboardSummary(response: AxiosResponse): Promise<ApiResponse_1OfDashboardSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDashboardSummaryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDashboardSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDashboardSummaryDto>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    assignmentDocument(documentId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/assign-document?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignmentDocument(_response);
        });
    }

    protected processAssignmentDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @param priority (optional) 
     * @return OK
     */
    changePriorityDocument(documentId: number | undefined, priority: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/change-priority-document?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePriorityDocument(_response);
        });
    }

    protected processChangePriorityDocument(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentGetFlowHistory(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfDocumentFlowHistoryDto> {
        let url_ = this.baseUrl + "/api/v1/document/get-flow-history?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentGetFlowHistory(_response);
        });
    }

    protected processDocumentGetFlowHistory(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfDocumentFlowHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfDocumentFlowHistoryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfDocumentFlowHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfDocumentFlowHistoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListDocumentPending(body: DocumentPendingGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfDocumentListDto> {
        let url_ = this.baseUrl + "/api/v1/document/get-list-pending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListDocumentPending(_response);
        });
    }

    protected processGetListDocumentPending(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfDocumentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfDocumentListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfDocumentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfDocumentListDto>(null as any);
    }

    /**
     * @param documentFileId (optional) 
     * @param formType (optional) 
     * @return OK
     */
    documentFileChangeType(documentFileId: number | undefined, formType: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/file-change-type?";
        if (documentFileId === null)
            throw new Error("The parameter 'documentFileId' cannot be null.");
        else if (documentFileId !== undefined)
            url_ += "documentFileId=" + encodeURIComponent("" + documentFileId) + "&";
        if (formType === null)
            throw new Error("The parameter 'formType' cannot be null.");
        else if (formType !== undefined)
            url_ += "formType=" + encodeURIComponent("" + formType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentFileChangeType(_response);
        });
    }

    protected processDocumentFileChangeType(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentDistribution(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/distribution?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentDistribution(_response);
        });
    }

    protected processDocumentDistribution(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    documentSendNotification(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/send-notification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentSendNotification(_response);
        });
    }

    protected processDocumentSendNotification(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentFileSaveExtract(body: DocumentFileSaveExtractDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/document-file-save-extract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentFileSaveExtract(_response);
        });
    }

    protected processDocumentFileSaveExtract(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    documentSaveMappingData(body: MappingDataDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfNullable_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/document-save-mapping-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentSaveMappingData(_response);
        });
    }

    protected processDocumentSaveMappingData(response: AxiosResponse): Promise<ApiResponse_1OfNullable_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfNullable_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfNullable_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfNullable_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param documentFileId (optional) 
     * @return OK
     */
    documentFileRemove(id: number | undefined, documentFileId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/document/document-file-remove?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (documentFileId === null)
            throw new Error("The parameter 'documentFileId' cannot be null.");
        else if (documentFileId !== undefined)
            url_ += "documentFileId=" + encodeURIComponent("" + documentFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocumentFileRemove(_response);
        });
    }

    protected processDocumentFileRemove(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    fileGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetById(_response);
        });
    }

    protected processFileGetById(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    fileGetMetaById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        let url_ = this.baseUrl + "/api/v1/file/get-meta?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetMetaById(_response);
        });
    }

    protected processFileGetMetaById(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFileMetaDataEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdate(body: FileUpdateCommand | undefined, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdate(_response);
        });
    }

    protected processFileUpdate(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateAvatar(body: FileUpdateAvatarCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateAvatar(_response);
        });
    }

    protected processFileUpdateAvatar(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateName(body: FileUpdateNameCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateName(_response);
        });
    }

    protected processFileUpdateName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateStatus(body: FileUpdateStatusCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateStatus(_response);
        });
    }

    protected processFileUpdateStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileGetList(body: FileGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetList(_response);
        });
    }

    protected processFileGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfFileEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(null as any);
    }

    /**
     * @param request (optional) 
     * @return OK
     */
    folderGetAll(request: FolderGetAllQuery | undefined, cancelToken?: CancelToken): Promise<FolderEntity[]> {
        let url_ = this.baseUrl + "/api/v1/file/folder-all?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetAll(_response);
        });
    }

    protected processFolderGetAll(response: AxiosResponse): Promise<FolderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FolderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity[]>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    folderGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetById(_response);
        });
    }

    protected processFolderGetById(response: AxiosResponse): Promise<FolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FolderEntity.fromJS(resultData200);
            return Promise.resolve<FolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderUpdate(body: FolderUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderUpdate(_response);
        });
    }

    protected processFolderUpdate(response: AxiosResponse): Promise<ApiResponse_1OfFolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFolderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderGetList(body: FolderGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        let url_ = this.baseUrl + "/api/v1/file/folder/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetList(_response);
        });
    }

    protected processFolderGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFolderNodeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderDelete(body: FolderDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/file/folder/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderDelete(_response);
        });
    }

    protected processFolderDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    uploadByUrl(url: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        let url_ = this.baseUrl + "/api/v1/file/file/upload-by-url?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadByUrl(_response);
        });
    }

    protected processUploadByUrl(response: AxiosResponse): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFileUploadByUrlResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/file-upload/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param filePath (optional) 
     * @return OK
     */
    displayFile(filePath: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/file-upload/display?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisplayFile(_response);
        });
    }

    protected processDisplayFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param documentId (optional) 
     * @param files (optional) 
     * @return OK
     */
    uploadFiles(userId: number | undefined, documentId: number | undefined, files: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/upload?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFiles(_response);
        });
    }

    protected processUploadFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @return OK
     */
    getIndices(session_id: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/indices?";
        if (session_id === null)
            throw new Error("The parameter 'session_id' cannot be null.");
        else if (session_id !== undefined)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIndices(_response);
        });
    }

    protected processGetIndices(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @param fileName (optional) 
     * @param body (optional) 
     * @return OK
     */
    getPollSubResult(session_id: string | undefined, fileName: string | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/sub_result?";
        if (session_id === null)
            throw new Error("The parameter 'session_id' cannot be null.");
        else if (session_id !== undefined)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPollSubResult(_response);
        });
    }

    protected processGetPollSubResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @return OK
     */
    getResult(session_id: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/get_result?";
        if (session_id === null)
            throw new Error("The parameter 'session_id' cannot be null.");
        else if (session_id !== undefined)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResult(_response);
        });
    }

    protected processGetResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param session_id (optional) 
     * @return OK
     */
    saveSummary(session_id: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/save_summary_to_document_by_session?";
        if (session_id === null)
            throw new Error("The parameter 'session_id' cannot be null.");
        else if (session_id !== undefined)
            url_ += "session_id=" + encodeURIComponent("" + session_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSummary(_response);
        });
    }

    protected processSaveSummary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    authencationOfIDUS( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/authencation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthencationOfIDUS(_response);
        });
    }

    protected processAuthencationOfIDUS(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param documentFileId (optional) 
     * @param obj (optional) 
     * @return OK
     */
    getmitDocument(documentFileId: number | undefined, obj: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/idus/get-document-session?";
        if (documentFileId === null)
            throw new Error("The parameter 'documentFileId' cannot be null.");
        else if (documentFileId !== undefined)
            url_ += "documentFileId=" + encodeURIComponent("" + documentFileId) + "&";
        if (obj === null)
            throw new Error("The parameter 'obj' cannot be null.");
        else if (obj !== undefined)
            url_ += "obj=" + encodeURIComponent("" + obj) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetmitDocument(_response);
        });
    }

    protected processGetmitDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveInsuranceCompany(body: InsuranceCompanyEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInsuranceCompanyEntity> {
        let url_ = this.baseUrl + "/api/v1/insurance-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveInsuranceCompany(_response);
        });
    }

    protected processSaveInsuranceCompany(response: AxiosResponse): Promise<ApiResponse_1OfInsuranceCompanyEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInsuranceCompanyEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInsuranceCompanyEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInsuranceCompanyEntity>(null as any);
    }

    /**
     * @return OK
     */
    insuranceCompanyGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfInsuranceCompanyEntity> {
        let url_ = this.baseUrl + "/api/v1/insurance-company/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsuranceCompanyGetById(_response);
        });
    }

    protected processInsuranceCompanyGetById(response: AxiosResponse): Promise<ApiResponse_1OfInsuranceCompanyEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInsuranceCompanyEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInsuranceCompanyEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInsuranceCompanyEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    insuranceCompanyGetList(body: InsuranceCompanyGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity> {
        let url_ = this.baseUrl + "/api/v1/insurance-company/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsuranceCompanyGetList(_response);
        });
    }

    protected processInsuranceCompanyGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity>(null as any);
    }

    /**
     * @return OK
     */
    insuranceCompanyDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/insurance-company/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsuranceCompanyDelete(_response);
        });
    }

    protected processInsuranceCompanyDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localityGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetByIds(_response);
        });
    }

    protected processLocalityGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localityGetList(body: LocalityGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetList(_response);
        });
    }

    protected processLocalityGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveMedicalFacility(body: MedicalFacilityEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfMedicalFacilityEntity> {
        let url_ = this.baseUrl + "/api/v1/medical-facility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMedicalFacility(_response);
        });
    }

    protected processSaveMedicalFacility(response: AxiosResponse): Promise<ApiResponse_1OfMedicalFacilityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfMedicalFacilityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfMedicalFacilityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfMedicalFacilityEntity>(null as any);
    }

    /**
     * @return OK
     */
    medicalFacilityGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfMedicalFacilityEntity> {
        let url_ = this.baseUrl + "/api/v1/medical-facility/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedicalFacilityGetById(_response);
        });
    }

    protected processMedicalFacilityGetById(response: AxiosResponse): Promise<ApiResponse_1OfMedicalFacilityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfMedicalFacilityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfMedicalFacilityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfMedicalFacilityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    medicalFacilityGetList(body: MedicalFacilityGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity> {
        let url_ = this.baseUrl + "/api/v1/medical-facility/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedicalFacilityGetList(_response);
        });
    }

    protected processMedicalFacilityGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity>(null as any);
    }

    /**
     * @return OK
     */
    medicalFacilityDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/medical-facility/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedicalFacilityDelete(_response);
        });
    }

    protected processMedicalFacilityDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getListNotification(pageIndex: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListNotificationDto> {
        let url_ = this.baseUrl + "/api/v1/notification/get-list-notification?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListNotification(_response);
        });
    }

    protected processGetListNotification(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListNotificationDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListNotificationDto>(null as any);
    }

    /**
     * @return OK
     */
    countNotificationUnRead( cancelToken?: CancelToken): Promise<ApiResponse_1OfInt32> {
        let url_ = this.baseUrl + "/api/v1/notification/count-notification-unread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountNotificationUnRead(_response);
        });
    }

    protected processCountNotificationUnRead(response: AxiosResponse): Promise<ApiResponse_1OfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt32.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt32>(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return OK
     */
    readNotification(notificationId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/notification/read-notification?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadNotification(_response);
        });
    }

    protected processReadNotification(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    readAllNotification( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/notification/read-all-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadAllNotification(_response);
        });
    }

    protected processReadAllNotification(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    originalDocumentGetList(body: OriginalDocumentListQueryDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfOriginalDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/original-document/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOriginalDocumentGetList(_response);
        });
    }

    protected processOriginalDocumentGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfOriginalDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfOriginalDocumentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfOriginalDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfOriginalDocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    originalDocumentCreateLadingBill(body: LadingBillCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/original-document/create-lading-bill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOriginalDocumentCreateLadingBill(_response);
        });
    }

    protected processOriginalDocumentCreateLadingBill(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param isMedCatRecive (optional) 
     * @param body (optional) 
     * @return OK
     */
    originalDocumentUpdateLadingBill(isMedCatRecive: boolean | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/original-document/update-lading-bill?";
        if (isMedCatRecive === null)
            throw new Error("The parameter 'isMedCatRecive' cannot be null.");
        else if (isMedCatRecive !== undefined)
            url_ += "isMedCatRecive=" + encodeURIComponent("" + isMedCatRecive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOriginalDocumentUpdateLadingBill(_response);
        });
    }

    protected processOriginalDocumentUpdateLadingBill(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param ladingBillId (optional) 
     * @return OK
     */
    originalDocumentGetLadingBill(ladingBillId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLadingBillDetailDto> {
        let url_ = this.baseUrl + "/api/v1/original-document/get-lading-bill?";
        if (ladingBillId === null)
            throw new Error("The parameter 'ladingBillId' cannot be null.");
        else if (ladingBillId !== undefined)
            url_ += "ladingBillId=" + encodeURIComponent("" + ladingBillId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOriginalDocumentGetLadingBill(_response);
        });
    }

    protected processOriginalDocumentGetLadingBill(response: AxiosResponse): Promise<ApiResponse_1OfLadingBillDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLadingBillDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLadingBillDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLadingBillDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListPaymentRequest(body: PaymentRequestGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfRequestPaymentDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaymentRequest(_response);
        });
    }

    protected processGetListPaymentRequest(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfRequestPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfRequestPaymentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfRequestPaymentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfRequestPaymentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createPaymentRequest(body: PaymentRequestCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPaymentRequestEntity> {
        let url_ = this.baseUrl + "/api/v1/payment-request/create-payment-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePaymentRequest(_response);
        });
    }

    protected processCreatePaymentRequest(response: AxiosResponse): Promise<ApiResponse_1OfPaymentRequestEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPaymentRequestEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPaymentRequestEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPaymentRequestEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListDocumentNotPaid(body: GetListDocumentNotPaidQueryDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-list-document-not-paid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListDocumentNotPaid(_response);
        });
    }

    protected processGetListDocumentNotPaid(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getDetailPayment(body: PaymentRequestGetById | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailPayment(_response);
        });
    }

    protected processGetDetailPayment(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    paymentRequestGetSummary(body: PaymentRequestGetById | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPaymentRequestSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-summary-by-payment-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymentRequestGetSummary(_response);
        });
    }

    protected processPaymentRequestGetSummary(response: AxiosResponse): Promise<ApiResponse_1OfPaymentRequestSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPaymentRequestSummaryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPaymentRequestSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPaymentRequestSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getSummaryForListPayment(body: PaymentRequestGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPaymentRequestSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-summary-for-list-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummaryForListPayment(_response);
        });
    }

    protected processGetSummaryForListPayment(response: AxiosResponse): Promise<ApiResponse_1OfPaymentRequestSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPaymentRequestSummaryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPaymentRequestSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPaymentRequestSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    paymentDocumentTimeSave(body: PaymentDocumentTimeQueryDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/payment-request/payment-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymentDocumentTimeSave(_response);
        });
    }

    protected processPaymentDocumentTimeSave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param facility (optional) 
     * @param companyId (optional) 
     * @return OK
     */
    renderPeriodPaymentOfFC(facility: number | undefined, companyId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRenderPaymentPeriodDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/render-period-payment-fc?";
        if (facility === null)
            throw new Error("The parameter 'facility' cannot be null.");
        else if (facility !== undefined)
            url_ += "facility=" + encodeURIComponent("" + facility) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenderPeriodPaymentOfFC(_response);
        });
    }

    protected processRenderPeriodPaymentOfFC(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRenderPaymentPeriodDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRenderPaymentPeriodDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRenderPaymentPeriodDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRenderPaymentPeriodDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPaymentForFacility(body: ListPaymentForFacilityOrCompanyFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-payment-for-facility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentForFacility(_response);
        });
    }

    protected processGetPaymentForFacility(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPaymentForCompany(body: ListPaymentForFacilityOrCompanyFilterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/payment-request/get-payment-for-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentForCompany(_response);
        });
    }

    protected processGetPaymentForCompany(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    roleSave(body: RoleDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/role/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleSave(_response);
        });
    }

    protected processRoleSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @return OK
     */
    roleGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetById(_response);
        });
    }

    protected processRoleGetById(response: AxiosResponse): Promise<ApiResponse_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return OK
     */
    roleGetList(keyword: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/list?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetList(_response);
        });
    }

    protected processRoleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(null as any);
    }

    /**
     * @return OK
     */
    getListModule( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        let url_ = this.baseUrl + "/api/v1/role/list-module";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListModule(_response);
        });
    }

    protected processGetListModule(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfEnumListEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    roleDelete(id: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/role/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleDelete(_response);
        });
    }

    protected processRoleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return OK
     */
    answerUrl(from: string | undefined, to: string | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/api/v1/stringee-call/answer-url?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnswerUrl(_response);
        });
    }

    protected processAnswerUrl(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @return OK
     */
    generateJwtToken( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/stringee-call/gen-access-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateJwtToken(_response);
        });
    }

    protected processGenerateJwtToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    initSystem( cancelToken?: CancelToken): Promise<ApiResponse_1OfSystemInitDto> {
        let url_ = this.baseUrl + "/api/v1/system/init";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitSystem(_response);
        });
    }

    protected processInitSystem(response: AxiosResponse): Promise<ApiResponse_1OfSystemInitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSystemInitDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSystemInitDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSystemInitDto>(null as any);
    }

    /**
     * @return OK
     */
    tagGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetById(_response);
        });
    }

    protected processTagGetById(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTag(body: TagDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTag(_response);
        });
    }

    protected processSaveTag(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetList(body: TagGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetList(_response);
        });
    }

    protected processTagGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTagListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(null as any);
    }

    /**
     * @return OK
     */
    tagDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagDelete(_response);
        });
    }

    protected processTagDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isHot (optional) 
     * @return OK
     */
    tagUpadteHot(id: number | undefined, isHot: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/update-hot?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isHot === null)
            throw new Error("The parameter 'isHot' cannot be null.");
        else if (isHot !== undefined)
            url_ += "IsHot=" + encodeURIComponent("" + isHot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagUpadteHot(_response);
        });
    }

    protected processTagUpadteHot(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newsId (optional) 
     * @return OK
     */
    tagRemoveNews(id: number | undefined, newsId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/remove-news?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newsId === null)
            throw new Error("The parameter 'newsId' cannot be null.");
        else if (newsId !== undefined)
            url_ += "newsId=" + encodeURIComponent("" + newsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagRemoveNews(_response);
        });
    }

    protected processTagRemoveNews(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagAddNews(body: TagAddNewsDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/add-news";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagAddNews(_response);
        });
    }

    protected processTagAddNews(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    testSendHideInfo( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-send-hide-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendHideInfo(_response);
        });
    }

    protected processTestSendHideInfo(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    testKafka( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/test/test-kafka";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestKafka(_response);
        });
    }

    protected processTestKafka(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    testNotification( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestNotification(_response);
        });
    }

    protected processTestNotification(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    testParseJson( cancelToken?: CancelToken): Promise<ApiResponse_1OfResponseX> {
        let url_ = this.baseUrl + "/api/v1/test/test-parsejson";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestParseJson(_response);
        });
    }

    protected processTestParseJson(response: AxiosResponse): Promise<ApiResponse_1OfResponseX> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfResponseX.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfResponseX>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfResponseX>(null as any);
    }

    /**
     * @return OK
     */
    testLog( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLog(_response);
        });
    }

    protected processTestLog(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    readSampleExtraction( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/test/read-sample-extraction";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReadSampleExtraction(_response);
        });
    }

    protected processReadSampleExtraction(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    testSendExtractInfo( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-send-extract-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestSendExtractInfo(_response);
        });
    }

    protected processTestSendExtractInfo(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    sendExtractInfo( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/send-extract-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendExtractInfo(_response);
        });
    }

    protected processSendExtractInfo(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userMobileTokenSave(body: UserMobileTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-mobile-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserMobileTokenSave(_response);
        });
    }

    protected processUserMobileTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserMobileTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    roleGetByUser(userId: number | undefined, id: string, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/user-permission/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetByUser(_response);
        });
    }

    protected processRoleGetByUser(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userReportList(body: UserReportQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserReportDto> {
        let url_ = this.baseUrl + "/api/v1/user-report/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserReportList(_response);
        });
    }

    protected processUserReportList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserReportDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserReportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserReportDto>(null as any);
    }

    /**
     * @return OK
     */
    userReportCount( cancelToken?: CancelToken): Promise<ApiResponse_1OfUserReportCountDto> {
        let url_ = this.baseUrl + "/api/v1/user-report/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserReportCount(_response);
        });
    }

    protected processUserReportCount(response: AxiosResponse): Promise<ApiResponse_1OfUserReportCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserReportCountDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserReportCountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserReportCountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenSave(body: UserWebTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserWebTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenSave(_response);
        });
    }

    protected processUserWebTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserWebTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserWebTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenDelete(body: UserWebTokenDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenDelete(_response);
        });
    }

    protected processUserWebTokenDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    generateVapidKeys( cancelToken?: CancelToken): Promise<ApiResponse_1OfVapidDetails> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/generate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateVapidKeys(_response);
        });
    }

    protected processGenerateVapidKeys(response: AxiosResponse): Promise<ApiResponse_1OfVapidDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfVapidDetails.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfVapidDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfVapidDetails>(null as any);
    }

    /**
     * @return OK
     */
    getWeatherForecast( cancelToken?: CancelToken): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/weatherforecast/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForecast(_response);
        });
    }

    protected processGetWeatherForecast(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WeatherForecast[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export class CategoryImportFromFolderResult implements ICategoryImportFromFolderResult {
    filesProcessed?: number;
    totalProcessed?: number;
    updated?: number;
    inserted?: number;
    errors?: number;
    errorMessages?: string[] | undefined;
    processedFiles?: string[] | undefined;

    constructor(data?: ICategoryImportFromFolderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filesProcessed = _data["filesProcessed"];
            this.totalProcessed = _data["totalProcessed"];
            this.updated = _data["updated"];
            this.inserted = _data["inserted"];
            this.errors = _data["errors"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            if (Array.isArray(_data["processedFiles"])) {
                this.processedFiles = [] as any;
                for (let item of _data["processedFiles"])
                    this.processedFiles!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryImportFromFolderResult {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryImportFromFolderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filesProcessed"] = this.filesProcessed;
        data["totalProcessed"] = this.totalProcessed;
        data["updated"] = this.updated;
        data["inserted"] = this.inserted;
        data["errors"] = this.errors;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.processedFiles)) {
            data["processedFiles"] = [];
            for (let item of this.processedFiles)
                data["processedFiles"].push(item);
        }
        return data;
    }
}

export interface ICategoryImportFromFolderResult {
    filesProcessed?: number;
    totalProcessed?: number;
    updated?: number;
    inserted?: number;
    errors?: number;
    errorMessages?: string[] | undefined;
    processedFiles?: string[] | undefined;
}

export class CategoryImportResult implements ICategoryImportResult {
    totalProcessed?: number;
    updated?: number;
    inserted?: number;
    errors?: number;
    errorMessages?: string[] | undefined;

    constructor(data?: ICategoryImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.updated = _data["updated"];
            this.inserted = _data["inserted"];
            this.errors = _data["errors"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["updated"] = this.updated;
        data["inserted"] = this.inserted;
        data["errors"] = this.errors;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

export interface ICategoryImportResult {
    totalProcessed?: number;
    updated?: number;
    inserted?: number;
    errors?: number;
    errorMessages?: string[] | undefined;
}

export class MappingDataDto implements IMappingDataDto {
    id?: number;
    data?: string | undefined;

    constructor(data?: IMappingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): MappingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        return data;
    }
}

export interface IMappingDataDto {
    id?: number;
    data?: string | undefined;
}

export class DocumentCountQuery implements IDocumentCountQuery {
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    userId?: number | undefined;

    constructor(data?: IDocumentCountQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DocumentCountQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCountQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDocumentCountQuery {
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    userId?: number | undefined;
}

export class DocumentGetListQuery implements IDocumentGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    customerKeyword?: string | undefined;
    diagnosis?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    treatmentTypes?: number[] | undefined;
    diseaseTypes?: number[] | undefined;
    rejectionType?: number | undefined;
    status?: DocumentEnum;
    listStatus?: number[] | undefined;
    processingStatus?: DocumentProcessingStatusEnum;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    approvalFromDate?: Date | undefined;
    approvalToDate?: Date | undefined;
    createdFromDate?: Date | undefined;
    createdToDate?: Date | undefined;
    totalPaymentFrom?: number | undefined;
    totalPaymentTo?: number | undefined;
    userId?: number | undefined;
    contractNumber?: string | undefined;
    contractType?: number | undefined;
    contractId?: number;
    tpaBy?: number;
    tpa?: Date | undefined;
    tpaReceiveDateFrom?: Date | undefined;
    tpaReceiveDateTo?: Date | undefined;

    constructor(data?: IDocumentGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.customerKeyword = _data["customerKeyword"];
            this.diagnosis = _data["diagnosis"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            if (Array.isArray(_data["diseaseTypes"])) {
                this.diseaseTypes = [] as any;
                for (let item of _data["diseaseTypes"])
                    this.diseaseTypes!.push(item);
            }
            this.rejectionType = _data["rejectionType"];
            this.status = _data["status"];
            if (Array.isArray(_data["listStatus"])) {
                this.listStatus = [] as any;
                for (let item of _data["listStatus"])
                    this.listStatus!.push(item);
            }
            this.processingStatus = _data["processingStatus"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.approvalFromDate = _data["approvalFromDate"] ? new Date(_data["approvalFromDate"].toString()) : <any>undefined;
            this.approvalToDate = _data["approvalToDate"] ? new Date(_data["approvalToDate"].toString()) : <any>undefined;
            this.createdFromDate = _data["createdFromDate"] ? new Date(_data["createdFromDate"].toString()) : <any>undefined;
            this.createdToDate = _data["createdToDate"] ? new Date(_data["createdToDate"].toString()) : <any>undefined;
            this.totalPaymentFrom = _data["totalPaymentFrom"];
            this.totalPaymentTo = _data["totalPaymentTo"];
            this.userId = _data["userId"];
            this.contractNumber = _data["contractNumber"];
            this.contractType = _data["contractType"];
            this.contractId = _data["contractId"];
            this.tpaBy = _data["tpaBy"];
            this.tpa = _data["tpa"] ? new Date(_data["tpa"].toString()) : <any>undefined;
            this.tpaReceiveDateFrom = _data["tpaReceiveDateFrom"] ? new Date(_data["tpaReceiveDateFrom"].toString()) : <any>undefined;
            this.tpaReceiveDateTo = _data["tpaReceiveDateTo"] ? new Date(_data["tpaReceiveDateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["customerKeyword"] = this.customerKeyword;
        data["diagnosis"] = this.diagnosis;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item);
        }
        if (Array.isArray(this.diseaseTypes)) {
            data["diseaseTypes"] = [];
            for (let item of this.diseaseTypes)
                data["diseaseTypes"].push(item);
        }
        data["rejectionType"] = this.rejectionType;
        data["status"] = this.status;
        if (Array.isArray(this.listStatus)) {
            data["listStatus"] = [];
            for (let item of this.listStatus)
                data["listStatus"].push(item);
        }
        data["processingStatus"] = this.processingStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["approvalFromDate"] = this.approvalFromDate ? this.approvalFromDate.toISOString() : <any>undefined;
        data["approvalToDate"] = this.approvalToDate ? this.approvalToDate.toISOString() : <any>undefined;
        data["createdFromDate"] = this.createdFromDate ? this.createdFromDate.toISOString() : <any>undefined;
        data["createdToDate"] = this.createdToDate ? this.createdToDate.toISOString() : <any>undefined;
        data["totalPaymentFrom"] = this.totalPaymentFrom;
        data["totalPaymentTo"] = this.totalPaymentTo;
        data["userId"] = this.userId;
        data["contractNumber"] = this.contractNumber;
        data["contractType"] = this.contractType;
        data["contractId"] = this.contractId;
        data["tpaBy"] = this.tpaBy;
        data["tpa"] = this.tpa ? this.tpa.toISOString() : <any>undefined;
        data["tpaReceiveDateFrom"] = this.tpaReceiveDateFrom ? this.tpaReceiveDateFrom.toISOString() : <any>undefined;
        data["tpaReceiveDateTo"] = this.tpaReceiveDateTo ? this.tpaReceiveDateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    customerKeyword?: string | undefined;
    diagnosis?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    treatmentTypes?: number[] | undefined;
    diseaseTypes?: number[] | undefined;
    rejectionType?: number | undefined;
    status?: DocumentEnum;
    listStatus?: number[] | undefined;
    processingStatus?: DocumentProcessingStatusEnum;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    approvalFromDate?: Date | undefined;
    approvalToDate?: Date | undefined;
    createdFromDate?: Date | undefined;
    createdToDate?: Date | undefined;
    totalPaymentFrom?: number | undefined;
    totalPaymentTo?: number | undefined;
    userId?: number | undefined;
    contractNumber?: string | undefined;
    contractType?: number | undefined;
    contractId?: number;
    tpaBy?: number;
    tpa?: Date | undefined;
    tpaReceiveDateFrom?: Date | undefined;
    tpaReceiveDateTo?: Date | undefined;
}

export class DocumentMaxPaymentQuery implements IDocumentMaxPaymentQuery {
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    userId?: number | undefined;

    constructor(data?: IDocumentMaxPaymentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DocumentMaxPaymentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMaxPaymentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDocumentMaxPaymentQuery {
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    userId?: number | undefined;
}

export class InsuranceCompanyGetListQuery implements IInsuranceCompanyGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: InsuranceCompanyEnum;

    constructor(data?: IInsuranceCompanyGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InsuranceCompanyGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        return data;
    }
}

export interface IInsuranceCompanyGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: InsuranceCompanyEnum;
}

export class LocalityGetListQuery implements ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;

    constructor(data?: ILocalityGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): LocalityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;
}

export class MedicalFacilityGetListQuery implements IMedicalFacilityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: MedicalFacilityEnum;
    province?: number | undefined;
    district?: number | undefined;
    ward?: number | undefined;

    constructor(data?: IMedicalFacilityGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.status = _data["status"];
            this.province = _data["province"];
            this.district = _data["district"];
            this.ward = _data["ward"];
        }
    }

    static fromJS(data: any): MedicalFacilityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalFacilityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        return data;
    }
}

export interface IMedicalFacilityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    status?: MedicalFacilityEnum;
    province?: number | undefined;
    district?: number | undefined;
    ward?: number | undefined;
}

export class DNTCaptchaApiResponse implements IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;

    constructor(data?: IDNTCaptchaApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dntCaptchaImgUrl = _data["dntCaptchaImgUrl"];
            this.dntCaptchaId = _data["dntCaptchaId"];
            this.dntCaptchaTextValue = _data["dntCaptchaTextValue"];
            this.dntCaptchaTokenValue = _data["dntCaptchaTokenValue"];
        }
    }

    static fromJS(data: any): DNTCaptchaApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DNTCaptchaApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dntCaptchaImgUrl"] = this.dntCaptchaImgUrl;
        data["dntCaptchaId"] = this.dntCaptchaId;
        data["dntCaptchaTextValue"] = this.dntCaptchaTextValue;
        data["dntCaptchaTokenValue"] = this.dntCaptchaTokenValue;
        return data;
    }
}

export interface IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;
}

export class ResponseX implements IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;

    constructor(data?: IResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.fileId = _data["fileId"];
            this.docType = _data["docType"];
            if (_data["pages"]) {
                this.pages = {} as any;
                for (let key in _data["pages"]) {
                    if (_data["pages"].hasOwnProperty(key))
                        (<any>this.pages)![key] = _data["pages"][key] !== undefined ? _data["pages"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["fileId"] = this.fileId;
        data["docType"] = this.docType;
        if (this.pages) {
            data["pages"] = {};
            for (let key in this.pages) {
                if (this.pages.hasOwnProperty(key))
                    (<any>data["pages"])[key] = (<any>this.pages)[key];
            }
        }
        return data;
    }
}

export interface IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;
}

export class SystemEnums implements ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;

    constructor(data?: ISystemEnums) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.values = _data["values"] ? Enum.fromJS(_data["values"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EnumItemEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemEnums {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEnums();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["values"] = this.values ? this.values.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;
}

export class SystemInitDto implements ISystemInitDto {
    users?: UserWithSimpleInfoDto[] | undefined;
    category?: CategoryEntity[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    currentObject?: CurrentObjectDto;
    processingStatus?: { [key: string]: number[]; } | undefined;

    constructor(data?: ISystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryEntity.fromJS(item));
            }
            if (Array.isArray(_data["enums"])) {
                this.enums = [] as any;
                for (let item of _data["enums"])
                    this.enums!.push(SystemEnums.fromJS(item));
            }
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(RoleModuleDto.fromJS(item));
            }
            this.currentObject = _data["currentObject"] ? CurrentObjectDto.fromJS(_data["currentObject"]) : <any>undefined;
            if (_data["processingStatus"]) {
                this.processingStatus = {} as any;
                for (let key in _data["processingStatus"]) {
                    if (_data["processingStatus"].hasOwnProperty(key))
                        (<any>this.processingStatus)![key] = _data["processingStatus"][key] !== undefined ? _data["processingStatus"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): SystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item.toJSON());
        }
        if (Array.isArray(this.enums)) {
            data["enums"] = [];
            for (let item of this.enums)
                data["enums"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item.toJSON());
        }
        data["currentObject"] = this.currentObject ? this.currentObject.toJSON() : <any>undefined;
        if (this.processingStatus) {
            data["processingStatus"] = {};
            for (let key in this.processingStatus) {
                if (this.processingStatus.hasOwnProperty(key))
                    (<any>data["processingStatus"])[key] = (<any>this.processingStatus)[key];
            }
        }
        return data;
    }
}

export interface ISystemInitDto {
    users?: UserWithSimpleInfoDto[] | undefined;
    category?: CategoryEntity[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: RoleModuleDto[] | undefined;
    currentObject?: CurrentObjectDto;
    processingStatus?: { [key: string]: number[]; } | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    readonly temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.temperatureC = _data["temperatureC"];
            (<any>this).temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export class ChangeEmailDto implements IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;

    constructor(data?: IChangeEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.password = _data["password"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ChangeEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["password"] = this.password;
        data["email"] = this.email;
        return data;
    }
}

export interface IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.reNewPassword = _data["reNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["reNewPassword"] = this.reNewPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;
}

export class CurrentObjectDto implements ICurrentObjectDto {
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;

    constructor(data?: ICurrentObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CurrentObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface ICurrentObjectDto {
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;
}

export class Disable2FADto implements IDisable2FADto {
    code?: string | undefined;

    constructor(data?: IDisable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Disable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Disable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IDisable2FADto {
    code?: string | undefined;
}

export class Enable2FADto implements IEnable2FADto {
    code?: string | undefined;

    constructor(data?: IEnable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Enable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Enable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IEnable2FADto {
    code?: string | undefined;
}

export class LoginResponseDto implements ILoginResponseDto {
    require2Fa?: boolean;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;

    constructor(data?: ILoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.require2Fa = _data["require2Fa"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["require2Fa"] = this.require2Fa;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginResponseDto {
    require2Fa?: boolean;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;
}

export class LoginWith2FADto implements ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;

    constructor(data?: ILoginWith2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LoginWith2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWith2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        return data;
    }
}

export interface ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;
}

export class RefreshTokenResponseDto implements IRefreshTokenResponseDto {
    token?: string | undefined;

    constructor(data?: IRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IRefreshTokenResponseDto {
    token?: string | undefined;
}

export class RegisterDto implements IRegisterDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;

    constructor(data?: IRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): RegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IRegisterDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
}

export class Setup2FADto implements ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;

    constructor(data?: ISetup2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedKey = _data["sharedKey"];
            this.authenticatorUri = _data["authenticatorUri"];
        }
    }

    static fromJS(data: any): Setup2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Setup2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedKey"] = this.sharedKey;
        data["authenticatorUri"] = this.authenticatorUri;
        return data;
    }
}

export interface ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;
}

export class UpdateAvatarDto implements IUpdateAvatarDto {
    avatar?: string | undefined;

    constructor(data?: IUpdateAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateAvatarDto {
    avatar?: string | undefined;
}

export class UpdateInfoDto implements IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IUpdateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
}

export class UserInfoDto implements IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.lastLoginDate = _data["lastLoginDate"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["lastLoginDate"] = this.lastLoginDate;
        return data;
    }
}

export interface IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;
}

export class DocumentFileSaveExtractDto implements IDocumentFileSaveExtractDto {
    id?: number;
    extractInfo?: string | undefined;

    constructor(data?: IDocumentFileSaveExtractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.extractInfo = _data["extractInfo"];
        }
    }

    static fromJS(data: any): DocumentFileSaveExtractDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFileSaveExtractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["extractInfo"] = this.extractInfo;
        return data;
    }
}

export interface IDocumentFileSaveExtractDto {
    id?: number;
    extractInfo?: string | undefined;
}

export class DocumentFileSendDto implements IDocumentFileSendDto {
    id?: number;
    fileName?: string | undefined;
    url?: string | undefined;
    fileParts?: string[] | undefined;

    constructor(data?: IDocumentFileSendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            if (Array.isArray(_data["fileParts"])) {
                this.fileParts = [] as any;
                for (let item of _data["fileParts"])
                    this.fileParts!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentFileSendDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFileSendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        if (Array.isArray(this.fileParts)) {
            data["fileParts"] = [];
            for (let item of this.fileParts)
                data["fileParts"].push(item);
        }
        return data;
    }
}

export interface IDocumentFileSendDto {
    id?: number;
    fileName?: string | undefined;
    url?: string | undefined;
    fileParts?: string[] | undefined;
}

export class DocumentFlowHistoryDto implements IDocumentFlowHistoryDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
    documentId?: number;
    toUserId?: number;
    oldStatus?: DocumentEnum;
    status?: DocumentEnum;
    note?: string | undefined;
    createdByName?: string | undefined;
    toUserName?: string | undefined;

    constructor(data?: IDocumentFlowHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.documentId = _data["documentId"];
            this.toUserId = _data["toUserId"];
            this.oldStatus = _data["oldStatus"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.createdByName = _data["createdByName"];
            this.toUserName = _data["toUserName"];
        }
    }

    static fromJS(data: any): DocumentFlowHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFlowHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["documentId"] = this.documentId;
        data["toUserId"] = this.toUserId;
        data["oldStatus"] = this.oldStatus;
        data["status"] = this.status;
        data["note"] = this.note;
        data["createdByName"] = this.createdByName;
        data["toUserName"] = this.toUserName;
        return data;
    }
}

export interface IDocumentFlowHistoryDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
    documentId?: number;
    toUserId?: number;
    oldStatus?: DocumentEnum;
    status?: DocumentEnum;
    note?: string | undefined;
    createdByName?: string | undefined;
    toUserName?: string | undefined;
}

export class FileUploadByUrlResponseDto implements IFileUploadByUrlResponseDto {
    path?: string | undefined;

    constructor(data?: IFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): FileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data;
    }
}

export interface IFileUploadByUrlResponseDto {
    path?: string | undefined;
}

export class FolderNodeDataDto implements IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;

    constructor(data?: IFolderNodeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.fileCount = _data["fileCount"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): FolderNodeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["fileCount"] = this.fileCount;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;
}

export class FolderNodeDto implements IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;

    constructor(data?: IFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.data = _data["data"] ? FolderNodeDataDto.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FolderNodeDto.fromJS(item));
            }
            this.state = _data["state"] ? FolderNodeStateDto.fromJS(_data["state"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;
}

export class FolderNodeStateDto implements IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;

    constructor(data?: IFolderNodeStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.opened = _data["opened"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): FolderNodeStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["opened"] = this.opened;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;
}

export class FolderUpdateDto implements IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;
}

export class TagDto implements ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHidden?: boolean;
    isHotTag?: boolean;
    mode?: number;
    type?: number;
    newsCount?: number;
    status?: number;
    avatar?: string | undefined;
    zoneId?: number;
    subZoneId?: number;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeyword?: string | undefined;
    description?: string | undefined;
    content?: string | undefined;
    isPR?: boolean;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.unsignName = _data["unsignName"];
            this.url = _data["url"];
            this.isHidden = _data["isHidden"];
            this.isHotTag = _data["isHotTag"];
            this.mode = _data["mode"];
            this.type = _data["type"];
            this.newsCount = _data["newsCount"];
            this.status = _data["status"];
            this.avatar = _data["avatar"];
            this.zoneId = _data["zoneId"];
            this.subZoneId = _data["subZoneId"];
            this.metaTitle = _data["metaTitle"];
            this.metaDescription = _data["metaDescription"];
            this.metaKeyword = _data["metaKeyword"];
            this.description = _data["description"];
            this.content = _data["content"];
            this.isPR = _data["isPR"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["unsignName"] = this.unsignName;
        data["url"] = this.url;
        data["isHidden"] = this.isHidden;
        data["isHotTag"] = this.isHotTag;
        data["mode"] = this.mode;
        data["type"] = this.type;
        data["newsCount"] = this.newsCount;
        data["status"] = this.status;
        data["avatar"] = this.avatar;
        data["zoneId"] = this.zoneId;
        data["subZoneId"] = this.subZoneId;
        data["metaTitle"] = this.metaTitle;
        data["metaDescription"] = this.metaDescription;
        data["metaKeyword"] = this.metaKeyword;
        data["description"] = this.description;
        data["content"] = this.content;
        data["isPR"] = this.isPR;
        return data;
    }
}

export interface ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHidden?: boolean;
    isHotTag?: boolean;
    mode?: number;
    type?: number;
    newsCount?: number;
    status?: number;
    avatar?: string | undefined;
    zoneId?: number;
    subZoneId?: number;
    metaTitle?: string | undefined;
    metaDescription?: string | undefined;
    metaKeyword?: string | undefined;
    description?: string | undefined;
    content?: string | undefined;
    isPR?: boolean;
}

export class GetListLogQuery implements IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IGetListLogQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.objectType = _data["objectType"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetListLogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListLogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["objectType"] = this.objectType;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class GetListUserForCreateChatGroupQuery implements IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;

    constructor(data?: IGetListUserForCreateChatGroupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.chatGroupType = _data["chatGroupType"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): GetListUserForCreateChatGroupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListUserForCreateChatGroupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["chatGroupType"] = this.chatGroupType;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
}

export class ContractGetListQuery implements IContractGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    companyId?: number;
    type?: number;
    status?: number;
    keyword?: string | undefined;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;

    constructor(data?: IContractGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.code = _data["code"];
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.keyword = _data["keyword"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.effectiveToDate = _data["effectiveToDate"] ? new Date(_data["effectiveToDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ContractGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["code"] = this.code;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["keyword"] = this.keyword;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IContractGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    companyId?: number;
    type?: number;
    status?: number;
    keyword?: string | undefined;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
}

export class DocumentPendingGetListQuery implements IDocumentPendingGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    customerKeyword?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    createdFromDate?: Date | undefined;
    createdToDate?: Date | undefined;
    priority?: number | undefined;
    documentType?: number | undefined;
    treatmentTypes?: number[] | undefined;

    constructor(data?: IDocumentPendingGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.customerKeyword = _data["customerKeyword"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.createdFromDate = _data["createdFromDate"] ? new Date(_data["createdFromDate"].toString()) : <any>undefined;
            this.createdToDate = _data["createdToDate"] ? new Date(_data["createdToDate"].toString()) : <any>undefined;
            this.priority = _data["priority"];
            this.documentType = _data["documentType"];
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentPendingGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPendingGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["customerKeyword"] = this.customerKeyword;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["createdFromDate"] = this.createdFromDate ? this.createdFromDate.toISOString() : <any>undefined;
        data["createdToDate"] = this.createdToDate ? this.createdToDate.toISOString() : <any>undefined;
        data["priority"] = this.priority;
        data["documentType"] = this.documentType;
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item);
        }
        return data;
    }
}

export interface IDocumentPendingGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    customerKeyword?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    createdFromDate?: Date | undefined;
    createdToDate?: Date | undefined;
    priority?: number | undefined;
    documentType?: number | undefined;
    treatmentTypes?: number[] | undefined;
}

export class FileUpdateAvatarCommand implements IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;

    constructor(data?: IFileUpdateAvatarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): FileUpdateAvatarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateAvatarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;
}

export class FileUpdateCommand implements IFileUpdateCommand {
    file?: FileEntity;

    constructor(data?: IFileUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileEntity.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUpdateCommand {
    file?: FileEntity;
}

export class FileUpdateNameCommand implements IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IFileUpdateNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileUpdateNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;
}

export class FileUpdateStatusCommand implements IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;

    constructor(data?: IFileUpdateStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileUpdateStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;
}

export class FolderDeleteCommand implements IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;

    constructor(data?: IFolderDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moveFileToFolderId = _data["moveFileToFolderId"];
        }
    }

    static fromJS(data: any): FolderDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moveFileToFolderId"] = this.moveFileToFolderId;
        return data;
    }
}

export interface IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;
}

export class FolderUpdateCommand implements IFolderUpdateCommand {
    folder?: FolderUpdateDto;

    constructor(data?: IFolderUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder = _data["folder"] ? FolderUpdateDto.fromJS(_data["folder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFolderUpdateCommand {
    folder?: FolderUpdateDto;
}

export class UserMobileTokenUpdateCommand implements IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;

    constructor(data?: IUserMobileTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserMobileTokenEntity.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMobileTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;
}

export class UserWebTokenDeleteCommand implements IUserWebTokenDeleteCommand {
    id?: number;

    constructor(data?: IUserWebTokenDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWebTokenDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserWebTokenDeleteCommand {
    id?: number;
}

export class UserWebTokenUpdateCommand implements IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;

    constructor(data?: IUserWebTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserWebTokenEntity.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserWebTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;
}

export class FileGetListQuery implements IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IFileGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.keyword = _data["keyword"];
            this.folderId = _data["folderId"];
            this.extensions = _data["extensions"];
            this.isGetAll = _data["isGetAll"];
            this.status = _data["status"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FileGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FileGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["keyword"] = this.keyword;
        data["folderId"] = this.folderId;
        data["extensions"] = this.extensions;
        data["isGetAll"] = this.isGetAll;
        data["status"] = this.status;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class FolderGetAllQuery implements IFolderGetAllQuery {

    constructor(data?: IFolderGetAllQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FolderGetAllQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetAllQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFolderGetAllQuery {
}

export class FolderGetListQuery implements IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;

    constructor(data?: IFolderGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.isGetAll = _data["isGetAll"];
        }
    }

    static fromJS(data: any): FolderGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["isGetAll"] = this.isGetAll;
        return data;
    }
}

export interface IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;
}

export class UserGetListQuery implements IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;

    constructor(data?: IUserGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): UserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
}

export class PaymentRequestGetById implements IPaymentRequestGetById {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    paymentRequestId?: number;
    listDocumentId?: number[] | undefined;
    code?: string | undefined;
    customerKeyword?: string | undefined;
    diseaseTypes?: number[] | undefined;
    treatmentTypes?: number[] | undefined;
    paymentStatus?: number | undefined;
    originalDocumentStatus?: number | undefined;

    constructor(data?: IPaymentRequestGetById) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.paymentRequestId = _data["paymentRequestId"];
            if (Array.isArray(_data["listDocumentId"])) {
                this.listDocumentId = [] as any;
                for (let item of _data["listDocumentId"])
                    this.listDocumentId!.push(item);
            }
            this.code = _data["code"];
            this.customerKeyword = _data["customerKeyword"];
            if (Array.isArray(_data["diseaseTypes"])) {
                this.diseaseTypes = [] as any;
                for (let item of _data["diseaseTypes"])
                    this.diseaseTypes!.push(item);
            }
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            this.paymentStatus = _data["paymentStatus"];
            this.originalDocumentStatus = _data["originalDocumentStatus"];
        }
    }

    static fromJS(data: any): PaymentRequestGetById {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestGetById();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["paymentRequestId"] = this.paymentRequestId;
        if (Array.isArray(this.listDocumentId)) {
            data["listDocumentId"] = [];
            for (let item of this.listDocumentId)
                data["listDocumentId"].push(item);
        }
        data["code"] = this.code;
        data["customerKeyword"] = this.customerKeyword;
        if (Array.isArray(this.diseaseTypes)) {
            data["diseaseTypes"] = [];
            for (let item of this.diseaseTypes)
                data["diseaseTypes"].push(item);
        }
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item);
        }
        data["paymentStatus"] = this.paymentStatus;
        data["originalDocumentStatus"] = this.originalDocumentStatus;
        return data;
    }
}

export interface IPaymentRequestGetById {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    paymentRequestId?: number;
    listDocumentId?: number[] | undefined;
    code?: string | undefined;
    customerKeyword?: string | undefined;
    diseaseTypes?: number[] | undefined;
    treatmentTypes?: number[] | undefined;
    paymentStatus?: number | undefined;
    originalDocumentStatus?: number | undefined;
}

export class PaymentRequestGetListQuery implements IPaymentRequestGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    facilityId?: number | undefined;
    userId?: number | undefined;
    companyId?: number | undefined;
    type?: number | undefined;
    paymentPeriodFromDate?: Date | undefined;
    paymentPeriodToDate?: Date | undefined;
    paymentRequestFromDate?: Date | undefined;
    paymentRequestToDate?: Date | undefined;
    paymentFromDate?: Date | undefined;
    paymentToDate?: Date | undefined;
    totalAmountFrom?: number | undefined;
    totalAmountTo?: number | undefined;
    listPaymentRequestId?: number[] | undefined;

    constructor(data?: IPaymentRequestGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.paymentPeriodFromDate = _data["paymentPeriodFromDate"] ? new Date(_data["paymentPeriodFromDate"].toString()) : <any>undefined;
            this.paymentPeriodToDate = _data["paymentPeriodToDate"] ? new Date(_data["paymentPeriodToDate"].toString()) : <any>undefined;
            this.paymentRequestFromDate = _data["paymentRequestFromDate"] ? new Date(_data["paymentRequestFromDate"].toString()) : <any>undefined;
            this.paymentRequestToDate = _data["paymentRequestToDate"] ? new Date(_data["paymentRequestToDate"].toString()) : <any>undefined;
            this.paymentFromDate = _data["paymentFromDate"] ? new Date(_data["paymentFromDate"].toString()) : <any>undefined;
            this.paymentToDate = _data["paymentToDate"] ? new Date(_data["paymentToDate"].toString()) : <any>undefined;
            this.totalAmountFrom = _data["totalAmountFrom"];
            this.totalAmountTo = _data["totalAmountTo"];
            if (Array.isArray(_data["listPaymentRequestId"])) {
                this.listPaymentRequestId = [] as any;
                for (let item of _data["listPaymentRequestId"])
                    this.listPaymentRequestId!.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentRequestGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["paymentPeriodFromDate"] = this.paymentPeriodFromDate ? this.paymentPeriodFromDate.toISOString() : <any>undefined;
        data["paymentPeriodToDate"] = this.paymentPeriodToDate ? this.paymentPeriodToDate.toISOString() : <any>undefined;
        data["paymentRequestFromDate"] = this.paymentRequestFromDate ? this.paymentRequestFromDate.toISOString() : <any>undefined;
        data["paymentRequestToDate"] = this.paymentRequestToDate ? this.paymentRequestToDate.toISOString() : <any>undefined;
        data["paymentFromDate"] = this.paymentFromDate ? this.paymentFromDate.toISOString() : <any>undefined;
        data["paymentToDate"] = this.paymentToDate ? this.paymentToDate.toISOString() : <any>undefined;
        data["totalAmountFrom"] = this.totalAmountFrom;
        data["totalAmountTo"] = this.totalAmountTo;
        if (Array.isArray(this.listPaymentRequestId)) {
            data["listPaymentRequestId"] = [];
            for (let item of this.listPaymentRequestId)
                data["listPaymentRequestId"].push(item);
        }
        return data;
    }
}

export interface IPaymentRequestGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    facilityId?: number | undefined;
    userId?: number | undefined;
    companyId?: number | undefined;
    type?: number | undefined;
    paymentPeriodFromDate?: Date | undefined;
    paymentPeriodToDate?: Date | undefined;
    paymentRequestFromDate?: Date | undefined;
    paymentRequestToDate?: Date | undefined;
    paymentFromDate?: Date | undefined;
    paymentToDate?: Date | undefined;
    totalAmountFrom?: number | undefined;
    totalAmountTo?: number | undefined;
    listPaymentRequestId?: number[] | undefined;
}

export class UserReportQuery implements IUserReportQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    treatmentTypes?: number[] | undefined;

    constructor(data?: IUserReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): UserReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item);
        }
        return data;
    }
}

export interface IUserReportQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    treatmentTypes?: number[] | undefined;
}

export class EnumItemEntity implements IEnumItemEntity {
    id?: number;
    name?: string | undefined;

    constructor(data?: IEnumItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnumItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEnumItemEntity {
    id?: number;
    name?: string | undefined;
}

export class EnumListEntity implements IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;

    constructor(data?: IEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isZone = _data["isZone"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(EnumListEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isZone"] = this.isZone;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;
}

export class ApiResponse_1OfCategoryImportFromFolderResult implements IApiResponse_1OfCategoryImportFromFolderResult {
    data?: CategoryImportFromFolderResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryImportFromFolderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryImportFromFolderResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryImportFromFolderResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryImportFromFolderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryImportFromFolderResult {
    data?: CategoryImportFromFolderResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryImportResult implements IApiResponse_1OfCategoryImportResult {
    data?: CategoryImportResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryImportResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryImportResult {
    data?: CategoryImportResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfResponseX implements IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ResponseX.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSystemInitDto implements IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SystemInitDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLoginResponseDto implements IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LoginResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRefreshTokenResponseDto implements IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RefreshTokenResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRegisterDto implements IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RegisterDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFileUploadByUrlResponseDto implements IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FileUploadByUrlResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTagDto implements IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TagDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupDetailDto implements IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupDetailDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfContractCountCompanyDto implements IApiResponse_1OfContractCountCompanyDto {
    data?: ContractCountCompanyDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfContractCountCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ContractCountCompanyDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfContractCountCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfContractCountCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfContractCountCompanyDto {
    data?: ContractCountCompanyDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfContractCountDto implements IApiResponse_1OfContractCountDto {
    data?: ContractCountDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfContractCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ContractCountDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfContractCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfContractCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfContractCountDto {
    data?: ContractCountDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfContractCustomerDto implements IApiResponse_1OfContractCustomerDto {
    data?: ContractCustomerDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfContractCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ContractCustomerDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfContractCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfContractCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfContractCustomerDto {
    data?: ContractCustomerDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDashboardSummaryDto implements IApiResponse_1OfDashboardSummaryDto {
    data?: DashboardSummaryDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDashboardSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DashboardSummaryDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDashboardSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDashboardSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDashboardSummaryDto {
    data?: DashboardSummaryDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDocumentDto implements IApiResponse_1OfDocumentDto {
    data?: DocumentDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DocumentDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDocumentDto {
    data?: DocumentDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLadingBillDetailDto implements IApiResponse_1OfLadingBillDetailDto {
    data?: LadingBillDetailDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLadingBillDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LadingBillDetailDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLadingBillDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLadingBillDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLadingBillDetailDto {
    data?: LadingBillDetailDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPaymentRequestSummaryDto implements IApiResponse_1OfPaymentRequestSummaryDto {
    data?: PaymentRequestSummaryDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPaymentRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PaymentRequestSummaryDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPaymentRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPaymentRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPaymentRequestSummaryDto {
    data?: PaymentRequestSummaryDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRoleDto implements IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RoleDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserReportCountDto implements IApiResponse_1OfUserReportCountDto {
    data?: UserReportCountDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserReportCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserReportCountDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserReportCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserReportCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserReportCountDto {
    data?: UserReportCountDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActivityLogEntity implements IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActivityLogEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfCategoryListDto implements IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfCategoryListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfContractListDto implements IApiResponse_1OfFilterResult_1OfContractListDto {
    data?: FilterResult_1OfContractListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfContractListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfContractListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfContractListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfContractListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfContractListDto {
    data?: FilterResult_1OfContractListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfDocumentListDto implements IApiResponse_1OfFilterResult_1OfDocumentListDto {
    data?: FilterResult_1OfDocumentListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfDocumentListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfDocumentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfDocumentListDto {
    data?: FilterResult_1OfDocumentListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListActivityLogDto implements IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListActivityLogDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatGroupDto implements IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatGroupDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto implements IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatMessageByGroupDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto implements IApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto {
    data?: FilterResult_1OfListDocumentNotPaidDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListDocumentNotPaidDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListDocumentNotPaidDto {
    data?: FilterResult_1OfListDocumentNotPaidDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListNotificationDto implements IApiResponse_1OfFilterResult_1OfListNotificationDto {
    data?: FilterResult_1OfListNotificationDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListNotificationDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListNotificationDto {
    data?: FilterResult_1OfListNotificationDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto implements IApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto {
    data?: FilterResult_1OfListPaymentForFacilityOrCompanyDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListPaymentForFacilityOrCompanyDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListPaymentForFacilityOrCompanyDto {
    data?: FilterResult_1OfListPaymentForFacilityOrCompanyDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfOriginalDocumentDto implements IApiResponse_1OfFilterResult_1OfOriginalDocumentDto {
    data?: FilterResult_1OfOriginalDocumentDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfOriginalDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfOriginalDocumentDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfOriginalDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfOriginalDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfOriginalDocumentDto {
    data?: FilterResult_1OfOriginalDocumentDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto implements IApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto {
    data?: FilterResult_1OfRequestPaymentDetailDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfRequestPaymentDetailDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfRequestPaymentDetailDto {
    data?: FilterResult_1OfRequestPaymentDetailDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfRequestPaymentDto implements IApiResponse_1OfFilterResult_1OfRequestPaymentDto {
    data?: FilterResult_1OfRequestPaymentDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfRequestPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfRequestPaymentDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfRequestPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfRequestPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfRequestPaymentDto {
    data?: FilterResult_1OfRequestPaymentDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTagListDto implements IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTagListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserListDto implements IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserReportDto implements IApiResponse_1OfFilterResult_1OfUserReportDto {
    data?: FilterResult_1OfUserReportDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserReportDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserReportDto {
    data?: FilterResult_1OfUserReportDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfFileEntity implements IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfFileEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity implements IApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity {
    data?: FilterResult_1OfInsuranceCompanyEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfInsuranceCompanyEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfInsuranceCompanyEntity {
    data?: FilterResult_1OfInsuranceCompanyEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfLocalityEntity implements IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfLocalityEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity implements IApiResponse_1OfFilterResult_1OfMedicalFacilityEntity {
    data?: FilterResult_1OfMedicalFacilityEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfMedicalFacilityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfMedicalFacilityEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfMedicalFacilityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfMedicalFacilityEntity {
    data?: FilterResult_1OfMedicalFacilityEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryEntity implements IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupEntity implements IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfContractEntity implements IApiResponse_1OfContractEntity {
    data?: ContractEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfContractEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ContractEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfContractEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfContractEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfContractEntity {
    data?: ContractEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDocumentEntity implements IApiResponse_1OfDocumentEntity {
    data?: DocumentEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDocumentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DocumentEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDocumentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDocumentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDocumentEntity {
    data?: DocumentEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFolderEntity implements IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FolderEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfInsuranceCompanyEntity implements IApiResponse_1OfInsuranceCompanyEntity {
    data?: InsuranceCompanyEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfInsuranceCompanyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InsuranceCompanyEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfInsuranceCompanyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfInsuranceCompanyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfInsuranceCompanyEntity {
    data?: InsuranceCompanyEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfMedicalFacilityEntity implements IApiResponse_1OfMedicalFacilityEntity {
    data?: MedicalFacilityEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfMedicalFacilityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MedicalFacilityEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfMedicalFacilityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfMedicalFacilityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfMedicalFacilityEntity {
    data?: MedicalFacilityEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserMobileTokenEntity implements IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserMobileTokenEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserWebTokenEntity implements IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserWebTokenEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPaymentRequestEntity implements IApiResponse_1OfPaymentRequestEntity {
    data?: PaymentRequestEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPaymentRequestEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PaymentRequestEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPaymentRequestEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPaymentRequestEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPaymentRequestEntity {
    data?: PaymentRequestEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfBoolean implements IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDictionary_2OfInt32AndInt32 implements IApiResponse_1OfDictionary_2OfInt32AndInt32 {
    data?: { [key: string]: number; } | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDictionary_2OfInt32AndInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDictionary_2OfInt32AndInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDictionary_2OfInt32AndInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDictionary_2OfInt32AndInt32 {
    data?: { [key: string]: number; } | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDocumentFlowHistoryDto implements IApiResponse_1OfList_1OfDocumentFlowHistoryDto {
    data?: DocumentFlowHistoryDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDocumentFlowHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentFlowHistoryDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDocumentFlowHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDocumentFlowHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDocumentFlowHistoryDto {
    data?: DocumentFlowHistoryDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFolderNodeDto implements IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FolderNodeDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfEnumListEntity implements IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnumListEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfEnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfEnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfDocumentListShortDto implements IApiResponse_1OfList_1OfDocumentListShortDto {
    data?: DocumentListShortDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfDocumentListShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentListShortDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfDocumentListShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfDocumentListShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfDocumentListShortDto {
    data?: DocumentListShortDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRenderPaymentPeriodDto implements IApiResponse_1OfList_1OfRenderPaymentPeriodDto {
    data?: RenderPaymentPeriodDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRenderPaymentPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RenderPaymentPeriodDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRenderPaymentPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRenderPaymentPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRenderPaymentPeriodDto {
    data?: RenderPaymentPeriodDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRoleDto implements IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRoleModuleDto implements IApiResponse_1OfList_1OfRoleModuleDto {
    data?: RoleModuleDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRoleModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleModuleDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRoleModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRoleModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRoleModuleDto {
    data?: RoleModuleDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserWithSimpleInfoDto implements IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFileMetaDataEntity implements IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileMetaDataEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLocalityEntity implements IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfInt32 implements IApiResponse_1OfInt32 {
    data?: number;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfInt32 {
    data?: number;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfInt64 implements IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfNullable_1OfBoolean implements IApiResponse_1OfNullable_1OfBoolean {
    data?: boolean | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfNullable_1OfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfNullable_1OfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfNullable_1OfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfNullable_1OfBoolean {
    data?: boolean | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfNullable_1OfDecimal implements IApiResponse_1OfNullable_1OfDecimal {
    data?: number | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfNullable_1OfDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfNullable_1OfDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfNullable_1OfDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfNullable_1OfDecimal {
    data?: number | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfObject implements IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfObject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfVapidDetails implements IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? VapidDetails.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfVapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfVapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export enum DocumentEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
}

export enum DocumentProcessingStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum ErrorCodeEnum {
    _0 = 0,
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _104 = 104,
    _105 = 105,
    _106 = 106,
    _107 = 107,
    _108 = 108,
    _109 = 109,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
    _118 = 118,
    _119 = 119,
    _120 = 120,
    _121 = 121,
    _122 = 122,
    _123 = 123,
    _200 = 200,
    _201 = 201,
    _202 = 202,
    _203 = 203,
    _204 = 204,
    _205 = 205,
    _206 = 206,
    _207 = 207,
    _208 = 208,
    _226 = 226,
    _300 = 300,
    _301 = 301,
    _302 = 302,
    _303 = 303,
    _304 = 304,
    _305 = 305,
    _306 = 306,
    _307 = 307,
    _308 = 308,
    _400 = 400,
    _401 = 401,
    _402 = 402,
    _403 = 403,
    _404 = 404,
    _405 = 405,
    _406 = 406,
    _407 = 407,
    _408 = 408,
    _409 = 409,
    _410 = 410,
    _411 = 411,
    _412 = 412,
    _413 = 413,
    _414 = 414,
    _415 = 415,
    _416 = 416,
    _417 = 417,
    _421 = 421,
    _422 = 422,
    _423 = 423,
    _424 = 424,
    _426 = 426,
    _428 = 428,
    _429 = 429,
    _431 = 431,
    _451 = 451,
    _500 = 500,
    _501 = 501,
    _502 = 502,
    _503 = 503,
    _504 = 504,
    _505 = 505,
    _506 = 506,
    _507 = 507,
    _508 = 508,
    _510 = 510,
    _511 = 511,
    __1 = -1,
}

export enum InsuranceCompanyEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum MedicalFacilityEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum MedicalFacilityTypeEnum {
    _1 = 1,
    _2 = 2,
}

export enum ModuleEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _98 = 98,
    _99 = 99,
}

export enum UserTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class CategoryGetListQuery implements ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;

    constructor(data?: ICategoryGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CategoryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["code"] = this.code;
        return data;
    }
}

export interface ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;
}

export class CategoryListDto implements ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    itemCode?: string | undefined;
    weight?: number;
    value?: number;

    constructor(data?: ICategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.itemCode = _data["itemCode"];
            this.weight = _data["weight"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["itemCode"] = this.itemCode;
        data["weight"] = this.weight;
        data["value"] = this.value;
        return data;
    }
}

export interface ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    itemCode?: string | undefined;
    weight?: number;
    value?: number;
}

export class ChatGroupDetailDto implements IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;

    constructor(data?: IChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["listUserOfGroup"])) {
                this.listUserOfGroup = [] as any;
                for (let item of _data["listUserOfGroup"])
                    this.listUserOfGroup!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): ChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        if (Array.isArray(this.listUserOfGroup)) {
            data["listUserOfGroup"] = [];
            for (let item of this.listUserOfGroup)
                data["listUserOfGroup"].push(item.toJSON());
        }
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;
}

export class ContractCompanyQueryDto implements IContractCompanyQueryDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    diagnosis?: string | undefined;
    treatmentTypes?: number[] | undefined;
    diseaseTypes?: number[] | undefined;
    processingStatus?: DocumentProcessingStatusEnum;
    listStatus?: number[] | undefined;
    totalPaymentFrom?: number | undefined;
    totalPaymentTo?: number | undefined;
    documentCode?: string | undefined;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    type?: number;
    contractCode?: string | undefined;
    keyword?: string | undefined;
    status?: number;

    constructor(data?: IContractCompanyQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.diagnosis = _data["diagnosis"];
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(item);
            }
            if (Array.isArray(_data["diseaseTypes"])) {
                this.diseaseTypes = [] as any;
                for (let item of _data["diseaseTypes"])
                    this.diseaseTypes!.push(item);
            }
            this.processingStatus = _data["processingStatus"];
            if (Array.isArray(_data["listStatus"])) {
                this.listStatus = [] as any;
                for (let item of _data["listStatus"])
                    this.listStatus!.push(item);
            }
            this.totalPaymentFrom = _data["totalPaymentFrom"];
            this.totalPaymentTo = _data["totalPaymentTo"];
            this.documentCode = _data["documentCode"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.effectiveToDate = _data["effectiveToDate"] ? new Date(_data["effectiveToDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.contractCode = _data["contractCode"];
            this.keyword = _data["keyword"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContractCompanyQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCompanyQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["diagnosis"] = this.diagnosis;
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item);
        }
        if (Array.isArray(this.diseaseTypes)) {
            data["diseaseTypes"] = [];
            for (let item of this.diseaseTypes)
                data["diseaseTypes"].push(item);
        }
        data["processingStatus"] = this.processingStatus;
        if (Array.isArray(this.listStatus)) {
            data["listStatus"] = [];
            for (let item of this.listStatus)
                data["listStatus"].push(item);
        }
        data["totalPaymentFrom"] = this.totalPaymentFrom;
        data["totalPaymentTo"] = this.totalPaymentTo;
        data["documentCode"] = this.documentCode;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["contractCode"] = this.contractCode;
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        return data;
    }
}

export interface IContractCompanyQueryDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    diagnosis?: string | undefined;
    treatmentTypes?: number[] | undefined;
    diseaseTypes?: number[] | undefined;
    processingStatus?: DocumentProcessingStatusEnum;
    listStatus?: number[] | undefined;
    totalPaymentFrom?: number | undefined;
    totalPaymentTo?: number | undefined;
    documentCode?: string | undefined;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    type?: number;
    contractCode?: string | undefined;
    keyword?: string | undefined;
    status?: number;
}

export class ContractCountCompanyDto implements IContractCountCompanyDto {
    countContract?: number;
    totalAmountCompensation?: number;
    countUser?: number;
    countDocument?: number;

    constructor(data?: IContractCountCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countContract = _data["countContract"];
            this.totalAmountCompensation = _data["totalAmountCompensation"];
            this.countUser = _data["countUser"];
            this.countDocument = _data["countDocument"];
        }
    }

    static fromJS(data: any): ContractCountCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCountCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countContract"] = this.countContract;
        data["totalAmountCompensation"] = this.totalAmountCompensation;
        data["countUser"] = this.countUser;
        data["countDocument"] = this.countDocument;
        return data;
    }
}

export interface IContractCountCompanyDto {
    countContract?: number;
    totalAmountCompensation?: number;
    countUser?: number;
    countDocument?: number;
}

export class ContractCountDto implements IContractCountDto {
    countContract?: number;
    totalAmountCompensation?: number;

    constructor(data?: IContractCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countContract = _data["countContract"];
            this.totalAmountCompensation = _data["totalAmountCompensation"];
        }
    }

    static fromJS(data: any): ContractCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countContract"] = this.countContract;
        data["totalAmountCompensation"] = this.totalAmountCompensation;
        return data;
    }
}

export interface IContractCountDto {
    countContract?: number;
    totalAmountCompensation?: number;
}

export class ContractCustomerDto implements IContractCustomerDto {
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContractCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuredFullName = _data["insuredFullName"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContractCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuredFullName"] = this.insuredFullName;
        data["identityCardNumber"] = this.identityCardNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        data["email"] = this.email;
        return data;
    }
}

export interface IContractCustomerDto {
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
    email?: string | undefined;
}

export class ContractFormDto implements IContractFormDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    cnbhCertificateNumber?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    type?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number;
    data?: string | undefined;
    lossNotificationPeriod?: number;
    companyId?: number;
    benefit?: string | undefined;
    coverages?: string | undefined;
    processStatus?: number;
    filePath?: string | undefined;
    userId?: number;
    isPaid?: boolean;
    benefits?: ContractBenefitEntity[] | undefined;

    constructor(data?: IContractFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.cnbhCertificateNumber = _data["cnbhCertificateNumber"];
            this.insuredFullName = _data["insuredFullName"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.effectiveToDate = _data["effectiveToDate"] ? new Date(_data["effectiveToDate"].toString()) : <any>undefined;
            this.fee = _data["fee"];
            this.data = _data["data"];
            this.lossNotificationPeriod = _data["lossNotificationPeriod"];
            this.companyId = _data["companyId"];
            this.benefit = _data["benefit"];
            this.coverages = _data["coverages"];
            this.processStatus = _data["processStatus"];
            this.filePath = _data["filePath"];
            this.userId = _data["userId"];
            this.isPaid = _data["isPaid"];
            if (Array.isArray(_data["benefits"])) {
                this.benefits = [] as any;
                for (let item of _data["benefits"])
                    this.benefits!.push(ContractBenefitEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["cnbhCertificateNumber"] = this.cnbhCertificateNumber;
        data["insuredFullName"] = this.insuredFullName;
        data["identityCardNumber"] = this.identityCardNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["type"] = this.type;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data["fee"] = this.fee;
        data["data"] = this.data;
        data["lossNotificationPeriod"] = this.lossNotificationPeriod;
        data["companyId"] = this.companyId;
        data["benefit"] = this.benefit;
        data["coverages"] = this.coverages;
        data["processStatus"] = this.processStatus;
        data["filePath"] = this.filePath;
        data["userId"] = this.userId;
        data["isPaid"] = this.isPaid;
        if (Array.isArray(this.benefits)) {
            data["benefits"] = [];
            for (let item of this.benefits)
                data["benefits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContractFormDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    cnbhCertificateNumber?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    type?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number;
    data?: string | undefined;
    lossNotificationPeriod?: number;
    companyId?: number;
    benefit?: string | undefined;
    coverages?: string | undefined;
    processStatus?: number;
    filePath?: string | undefined;
    userId?: number;
    isPaid?: boolean;
    benefits?: ContractBenefitEntity[] | undefined;
}

export class ContractListDto implements IContractListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    companyId?: number;
    companyName?: string | undefined;
    countDocuments?: number;
    countCompleteDocuments?: number;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    differenceAmount?: number;
    type?: number;
    status?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number | undefined;
    isPaid?: boolean;

    constructor(data?: IContractListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.insuredFullName = _data["insuredFullName"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.countDocuments = _data["countDocuments"];
            this.countCompleteDocuments = _data["countCompleteDocuments"];
            this.totalPayment = _data["totalPayment"];
            this.totalCost = _data["totalCost"];
            this.totalAmount = _data["totalAmount"];
            this.differenceAmount = _data["differenceAmount"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.effectiveToDate = _data["effectiveToDate"] ? new Date(_data["effectiveToDate"].toString()) : <any>undefined;
            this.fee = _data["fee"];
            this.isPaid = _data["isPaid"];
        }
    }

    static fromJS(data: any): ContractListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["insuredFullName"] = this.insuredFullName;
        data["identityCardNumber"] = this.identityCardNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["countDocuments"] = this.countDocuments;
        data["countCompleteDocuments"] = this.countCompleteDocuments;
        data["totalPayment"] = this.totalPayment;
        data["totalCost"] = this.totalCost;
        data["totalAmount"] = this.totalAmount;
        data["differenceAmount"] = this.differenceAmount;
        data["type"] = this.type;
        data["status"] = this.status;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data["fee"] = this.fee;
        data["isPaid"] = this.isPaid;
        return data;
    }
}

export interface IContractListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    companyId?: number;
    companyName?: string | undefined;
    countDocuments?: number;
    countCompleteDocuments?: number;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    differenceAmount?: number;
    type?: number;
    status?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number | undefined;
    isPaid?: boolean;
}

export class CreateChatGroupDto implements ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;

    constructor(data?: ICreateChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.name = _data["name"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): CreateChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["name"] = this.name;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;
}

export class DashboardByCategoryDto implements IDashboardByCategoryDto {
    id?: number;
    count?: number;
    amount?: number;

    constructor(data?: IDashboardByCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.count = _data["count"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): DashboardByCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardByCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["count"] = this.count;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IDashboardByCategoryDto {
    id?: number;
    count?: number;
    amount?: number;
}

export class DashboardSummaryDto implements IDashboardSummaryDto {
    total?: number;
    refuse?: number;
    pending?: number;
    supplement?: number;
    complete?: number;
    paymentAmount?: number;
    claimAmount?: number;
    differenceAmount?: number;
    treatmentType?: DashboardByCategoryDto[] | undefined;
    diseaseType?: DashboardByCategoryDto[] | undefined;
    rejectionType?: DashboardByCategoryDto[] | undefined;
    beyondAuthority?: number;
    totalAmount?: number;
    totalCost?: number | undefined;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;

    constructor(data?: IDashboardSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.refuse = _data["refuse"];
            this.pending = _data["pending"];
            this.supplement = _data["supplement"];
            this.complete = _data["complete"];
            this.paymentAmount = _data["paymentAmount"];
            this.claimAmount = _data["claimAmount"];
            this.differenceAmount = _data["differenceAmount"];
            if (Array.isArray(_data["treatmentType"])) {
                this.treatmentType = [] as any;
                for (let item of _data["treatmentType"])
                    this.treatmentType!.push(DashboardByCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["diseaseType"])) {
                this.diseaseType = [] as any;
                for (let item of _data["diseaseType"])
                    this.diseaseType!.push(DashboardByCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["rejectionType"])) {
                this.rejectionType = [] as any;
                for (let item of _data["rejectionType"])
                    this.rejectionType!.push(DashboardByCategoryDto.fromJS(item));
            }
            this.beyondAuthority = _data["beyondAuthority"];
            this.totalAmount = _data["totalAmount"];
            this.totalCost = _data["totalCost"];
            this.paidByPatient = _data["paidByPatient"];
            this.paidByInsurance = _data["paidByInsurance"];
        }
    }

    static fromJS(data: any): DashboardSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["refuse"] = this.refuse;
        data["pending"] = this.pending;
        data["supplement"] = this.supplement;
        data["complete"] = this.complete;
        data["paymentAmount"] = this.paymentAmount;
        data["claimAmount"] = this.claimAmount;
        data["differenceAmount"] = this.differenceAmount;
        if (Array.isArray(this.treatmentType)) {
            data["treatmentType"] = [];
            for (let item of this.treatmentType)
                data["treatmentType"].push(item.toJSON());
        }
        if (Array.isArray(this.diseaseType)) {
            data["diseaseType"] = [];
            for (let item of this.diseaseType)
                data["diseaseType"].push(item.toJSON());
        }
        if (Array.isArray(this.rejectionType)) {
            data["rejectionType"] = [];
            for (let item of this.rejectionType)
                data["rejectionType"].push(item.toJSON());
        }
        data["beyondAuthority"] = this.beyondAuthority;
        data["totalAmount"] = this.totalAmount;
        data["totalCost"] = this.totalCost;
        data["paidByPatient"] = this.paidByPatient;
        data["paidByInsurance"] = this.paidByInsurance;
        return data;
    }
}

export interface IDashboardSummaryDto {
    total?: number;
    refuse?: number;
    pending?: number;
    supplement?: number;
    complete?: number;
    paymentAmount?: number;
    claimAmount?: number;
    differenceAmount?: number;
    treatmentType?: DashboardByCategoryDto[] | undefined;
    diseaseType?: DashboardByCategoryDto[] | undefined;
    rejectionType?: DashboardByCategoryDto[] | undefined;
    beyondAuthority?: number;
    totalAmount?: number;
    totalCost?: number | undefined;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
}

export class DocumentDto implements IDocumentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;
    differenceAmount?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    tpaByAvatar?: string | undefined;
    tpaByName?: string | undefined;
    files?: DocumentFileEntity[] | undefined;
    changeLogs?: ChangeLogEntity[] | undefined;
    lastFiles?: DocumentFileEntity[] | undefined;
    fileParts?: DocumentFilePartEntity[] | undefined;
    sessionList?: string[] | undefined;
    idusFiles?: DocumentFileEntity[] | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.contractId = _data["contractId"];
            this.contractCode = _data["contractCode"];
            this.processedBy = _data["processedBy"];
            this.status = _data["status"];
            this.oldStatus = _data["oldStatus"];
            this.fullName = _data["fullName"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.idCard = _data["idCard"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.workUnit = _data["workUnit"];
            this.cardNumber = _data["cardNumber"];
            this.cardName = _data["cardName"];
            this.cardType = _data["cardType"];
            this.cardValidity = _data["cardValidity"] ? new Date(_data["cardValidity"].toString()) : <any>undefined;
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.rejectionType = _data["rejectionType"];
            this.diagnosis = _data["diagnosis"];
            this.daysInHospital = _data["daysInHospital"];
            this.insuranceBenefits = _data["insuranceBenefits"];
            this.paymentInfo = _data["paymentInfo"];
            this.totalPayment = _data["totalPayment"];
            this.totalCost = _data["totalCost"];
            this.totalAmount = _data["totalAmount"];
            this.paidByPatient = _data["paidByPatient"];
            this.paidByInsurance = _data["paidByInsurance"];
            this.isPaid = _data["isPaid"];
            this.tpaBy = _data["tpaBy"];
            this.tpaReceiveDate = _data["tpaReceiveDate"] ? new Date(_data["tpaReceiveDate"].toString()) : <any>undefined;
            this.processingTime = _data["processingTime"];
            this.sessionTime = _data["sessionTime"] ? new Date(_data["sessionTime"].toString()) : <any>undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.summary = _data["summary"];
            this.missingFile = _data["missingFile"];
            this.priority = _data["priority"];
            this.extractBy = _data["extractBy"];
            this.extractDate = _data["extractDate"] ? new Date(_data["extractDate"].toString()) : <any>undefined;
            this.medicalBy = _data["medicalBy"];
            this.medicalDate = _data["medicalDate"] ? new Date(_data["medicalDate"].toString()) : <any>undefined;
            this.idusProcessed = _data["idusProcessed"];
            this.note = _data["note"];
            this.isMappingContract = _data["isMappingContract"];
            this.mappingContractData = _data["mappingContractData"];
            this.benefitGroup = _data["benefitGroup"];
            this.differenceAmount = _data["differenceAmount"];
            this.senderName = _data["senderName"];
            this.senderAvatar = _data["senderAvatar"];
            this.tpaByAvatar = _data["tpaByAvatar"];
            this.tpaByName = _data["tpaByName"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(DocumentFileEntity.fromJS(item));
            }
            if (Array.isArray(_data["changeLogs"])) {
                this.changeLogs = [] as any;
                for (let item of _data["changeLogs"])
                    this.changeLogs!.push(ChangeLogEntity.fromJS(item));
            }
            if (Array.isArray(_data["lastFiles"])) {
                this.lastFiles = [] as any;
                for (let item of _data["lastFiles"])
                    this.lastFiles!.push(DocumentFileEntity.fromJS(item));
            }
            if (Array.isArray(_data["fileParts"])) {
                this.fileParts = [] as any;
                for (let item of _data["fileParts"])
                    this.fileParts!.push(DocumentFilePartEntity.fromJS(item));
            }
            if (Array.isArray(_data["sessionList"])) {
                this.sessionList = [] as any;
                for (let item of _data["sessionList"])
                    this.sessionList!.push(item);
            }
            if (Array.isArray(_data["idusFiles"])) {
                this.idusFiles = [] as any;
                for (let item of _data["idusFiles"])
                    this.idusFiles!.push(DocumentFileEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["contractId"] = this.contractId;
        data["contractCode"] = this.contractCode;
        data["processedBy"] = this.processedBy;
        data["status"] = this.status;
        data["oldStatus"] = this.oldStatus;
        data["fullName"] = this.fullName;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["idCard"] = this.idCard;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["workUnit"] = this.workUnit;
        data["cardNumber"] = this.cardNumber;
        data["cardName"] = this.cardName;
        data["cardType"] = this.cardType;
        data["cardValidity"] = this.cardValidity ? this.cardValidity.toISOString() : <any>undefined;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["rejectionType"] = this.rejectionType;
        data["diagnosis"] = this.diagnosis;
        data["daysInHospital"] = this.daysInHospital;
        data["insuranceBenefits"] = this.insuranceBenefits;
        data["paymentInfo"] = this.paymentInfo;
        data["totalPayment"] = this.totalPayment;
        data["totalCost"] = this.totalCost;
        data["totalAmount"] = this.totalAmount;
        data["paidByPatient"] = this.paidByPatient;
        data["paidByInsurance"] = this.paidByInsurance;
        data["isPaid"] = this.isPaid;
        data["tpaBy"] = this.tpaBy;
        data["tpaReceiveDate"] = this.tpaReceiveDate ? this.tpaReceiveDate.toISOString() : <any>undefined;
        data["processingTime"] = this.processingTime;
        data["sessionTime"] = this.sessionTime ? this.sessionTime.toISOString() : <any>undefined;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["summary"] = this.summary;
        data["missingFile"] = this.missingFile;
        data["priority"] = this.priority;
        data["extractBy"] = this.extractBy;
        data["extractDate"] = this.extractDate ? this.extractDate.toISOString() : <any>undefined;
        data["medicalBy"] = this.medicalBy;
        data["medicalDate"] = this.medicalDate ? this.medicalDate.toISOString() : <any>undefined;
        data["idusProcessed"] = this.idusProcessed;
        data["note"] = this.note;
        data["isMappingContract"] = this.isMappingContract;
        data["mappingContractData"] = this.mappingContractData;
        data["benefitGroup"] = this.benefitGroup;
        data["differenceAmount"] = this.differenceAmount;
        data["senderName"] = this.senderName;
        data["senderAvatar"] = this.senderAvatar;
        data["tpaByAvatar"] = this.tpaByAvatar;
        data["tpaByName"] = this.tpaByName;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.changeLogs)) {
            data["changeLogs"] = [];
            for (let item of this.changeLogs)
                data["changeLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.lastFiles)) {
            data["lastFiles"] = [];
            for (let item of this.lastFiles)
                data["lastFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.fileParts)) {
            data["fileParts"] = [];
            for (let item of this.fileParts)
                data["fileParts"].push(item.toJSON());
        }
        if (Array.isArray(this.sessionList)) {
            data["sessionList"] = [];
            for (let item of this.sessionList)
                data["sessionList"].push(item);
        }
        if (Array.isArray(this.idusFiles)) {
            data["idusFiles"] = [];
            for (let item of this.idusFiles)
                data["idusFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;
    differenceAmount?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    tpaByAvatar?: string | undefined;
    tpaByName?: string | undefined;
    files?: DocumentFileEntity[] | undefined;
    changeLogs?: ChangeLogEntity[] | undefined;
    lastFiles?: DocumentFileEntity[] | undefined;
    fileParts?: DocumentFilePartEntity[] | undefined;
    sessionList?: string[] | undefined;
    idusFiles?: DocumentFileEntity[] | undefined;
}

export class DocumentListDto implements IDocumentListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;
    differenceAmount?: number;
    companyName?: string | undefined;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    tpaByAvatar?: string | undefined;
    tpaByName?: string | undefined;
    processedByAvatar?: string | undefined;
    processedByName?: string | undefined;
    originalStatus?: number;
    facilityName?: string | undefined;

    constructor(data?: IDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.contractId = _data["contractId"];
            this.contractCode = _data["contractCode"];
            this.processedBy = _data["processedBy"];
            this.status = _data["status"];
            this.oldStatus = _data["oldStatus"];
            this.fullName = _data["fullName"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.idCard = _data["idCard"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.workUnit = _data["workUnit"];
            this.cardNumber = _data["cardNumber"];
            this.cardName = _data["cardName"];
            this.cardType = _data["cardType"];
            this.cardValidity = _data["cardValidity"] ? new Date(_data["cardValidity"].toString()) : <any>undefined;
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.rejectionType = _data["rejectionType"];
            this.diagnosis = _data["diagnosis"];
            this.daysInHospital = _data["daysInHospital"];
            this.insuranceBenefits = _data["insuranceBenefits"];
            this.paymentInfo = _data["paymentInfo"];
            this.totalPayment = _data["totalPayment"];
            this.totalCost = _data["totalCost"];
            this.totalAmount = _data["totalAmount"];
            this.paidByPatient = _data["paidByPatient"];
            this.paidByInsurance = _data["paidByInsurance"];
            this.isPaid = _data["isPaid"];
            this.tpaBy = _data["tpaBy"];
            this.tpaReceiveDate = _data["tpaReceiveDate"] ? new Date(_data["tpaReceiveDate"].toString()) : <any>undefined;
            this.processingTime = _data["processingTime"];
            this.sessionTime = _data["sessionTime"] ? new Date(_data["sessionTime"].toString()) : <any>undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.summary = _data["summary"];
            this.missingFile = _data["missingFile"];
            this.priority = _data["priority"];
            this.extractBy = _data["extractBy"];
            this.extractDate = _data["extractDate"] ? new Date(_data["extractDate"].toString()) : <any>undefined;
            this.medicalBy = _data["medicalBy"];
            this.medicalDate = _data["medicalDate"] ? new Date(_data["medicalDate"].toString()) : <any>undefined;
            this.idusProcessed = _data["idusProcessed"];
            this.note = _data["note"];
            this.isMappingContract = _data["isMappingContract"];
            this.mappingContractData = _data["mappingContractData"];
            this.benefitGroup = _data["benefitGroup"];
            this.differenceAmount = _data["differenceAmount"];
            this.companyName = _data["companyName"];
            this.senderName = _data["senderName"];
            this.senderAvatar = _data["senderAvatar"];
            this.tpaByAvatar = _data["tpaByAvatar"];
            this.tpaByName = _data["tpaByName"];
            this.processedByAvatar = _data["processedByAvatar"];
            this.processedByName = _data["processedByName"];
            this.originalStatus = _data["originalStatus"];
            this.facilityName = _data["facilityName"];
        }
    }

    static fromJS(data: any): DocumentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["contractId"] = this.contractId;
        data["contractCode"] = this.contractCode;
        data["processedBy"] = this.processedBy;
        data["status"] = this.status;
        data["oldStatus"] = this.oldStatus;
        data["fullName"] = this.fullName;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["idCard"] = this.idCard;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["workUnit"] = this.workUnit;
        data["cardNumber"] = this.cardNumber;
        data["cardName"] = this.cardName;
        data["cardType"] = this.cardType;
        data["cardValidity"] = this.cardValidity ? this.cardValidity.toISOString() : <any>undefined;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["rejectionType"] = this.rejectionType;
        data["diagnosis"] = this.diagnosis;
        data["daysInHospital"] = this.daysInHospital;
        data["insuranceBenefits"] = this.insuranceBenefits;
        data["paymentInfo"] = this.paymentInfo;
        data["totalPayment"] = this.totalPayment;
        data["totalCost"] = this.totalCost;
        data["totalAmount"] = this.totalAmount;
        data["paidByPatient"] = this.paidByPatient;
        data["paidByInsurance"] = this.paidByInsurance;
        data["isPaid"] = this.isPaid;
        data["tpaBy"] = this.tpaBy;
        data["tpaReceiveDate"] = this.tpaReceiveDate ? this.tpaReceiveDate.toISOString() : <any>undefined;
        data["processingTime"] = this.processingTime;
        data["sessionTime"] = this.sessionTime ? this.sessionTime.toISOString() : <any>undefined;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["summary"] = this.summary;
        data["missingFile"] = this.missingFile;
        data["priority"] = this.priority;
        data["extractBy"] = this.extractBy;
        data["extractDate"] = this.extractDate ? this.extractDate.toISOString() : <any>undefined;
        data["medicalBy"] = this.medicalBy;
        data["medicalDate"] = this.medicalDate ? this.medicalDate.toISOString() : <any>undefined;
        data["idusProcessed"] = this.idusProcessed;
        data["note"] = this.note;
        data["isMappingContract"] = this.isMappingContract;
        data["mappingContractData"] = this.mappingContractData;
        data["benefitGroup"] = this.benefitGroup;
        data["differenceAmount"] = this.differenceAmount;
        data["companyName"] = this.companyName;
        data["senderName"] = this.senderName;
        data["senderAvatar"] = this.senderAvatar;
        data["tpaByAvatar"] = this.tpaByAvatar;
        data["tpaByName"] = this.tpaByName;
        data["processedByAvatar"] = this.processedByAvatar;
        data["processedByName"] = this.processedByName;
        data["originalStatus"] = this.originalStatus;
        data["facilityName"] = this.facilityName;
        return data;
    }
}

export interface IDocumentListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;
    differenceAmount?: number;
    companyName?: string | undefined;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    tpaByAvatar?: string | undefined;
    tpaByName?: string | undefined;
    processedByAvatar?: string | undefined;
    processedByName?: string | undefined;
    originalStatus?: number;
    facilityName?: string | undefined;
}

export class DocumentListShortDto implements IDocumentListShortDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    idCard?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IDocumentListShortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fullName = _data["fullName"];
            this.idCard = _data["idCard"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): DocumentListShortDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentListShortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fullName"] = this.fullName;
        data["idCard"] = this.idCard;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IDocumentListShortDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    idCard?: string | undefined;
    phone?: string | undefined;
}

export class GetListDocumentNotPaidQueryDto implements IGetListDocumentNotPaidQueryDto {
    code?: string | undefined;
    keyword?: string | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    documentConfirmFromDate?: Date | undefined;
    documentConfirmToDate?: Date | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    pageIndex?: number;
    pageSize?: number;
    listStatus?: number[] | undefined;
    type?: number | undefined;
    documentCreatedFromDate?: Date | undefined;
    documentCreatedToDate?: Date | undefined;

    constructor(data?: IGetListDocumentNotPaidQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.keyword = _data["keyword"];
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.documentConfirmFromDate = _data["documentConfirmFromDate"] ? new Date(_data["documentConfirmFromDate"].toString()) : <any>undefined;
            this.documentConfirmToDate = _data["documentConfirmToDate"] ? new Date(_data["documentConfirmToDate"].toString()) : <any>undefined;
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["listStatus"])) {
                this.listStatus = [] as any;
                for (let item of _data["listStatus"])
                    this.listStatus!.push(item);
            }
            this.type = _data["type"];
            this.documentCreatedFromDate = _data["documentCreatedFromDate"] ? new Date(_data["documentCreatedFromDate"].toString()) : <any>undefined;
            this.documentCreatedToDate = _data["documentCreatedToDate"] ? new Date(_data["documentCreatedToDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListDocumentNotPaidQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetListDocumentNotPaidQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["keyword"] = this.keyword;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["documentConfirmFromDate"] = this.documentConfirmFromDate ? this.documentConfirmFromDate.toISOString() : <any>undefined;
        data["documentConfirmToDate"] = this.documentConfirmToDate ? this.documentConfirmToDate.toISOString() : <any>undefined;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.listStatus)) {
            data["listStatus"] = [];
            for (let item of this.listStatus)
                data["listStatus"].push(item);
        }
        data["type"] = this.type;
        data["documentCreatedFromDate"] = this.documentCreatedFromDate ? this.documentCreatedFromDate.toISOString() : <any>undefined;
        data["documentCreatedToDate"] = this.documentCreatedToDate ? this.documentCreatedToDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetListDocumentNotPaidQueryDto {
    code?: string | undefined;
    keyword?: string | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    documentConfirmFromDate?: Date | undefined;
    documentConfirmToDate?: Date | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    pageIndex?: number;
    pageSize?: number;
    listStatus?: number[] | undefined;
    type?: number | undefined;
    documentCreatedFromDate?: Date | undefined;
    documentCreatedToDate?: Date | undefined;
}

export class LadingBillCreateDto implements ILadingBillCreateDto {
    id?: number;
    code?: string | undefined;
    imageUrl?: string | undefined;
    documentIds?: number[] | undefined;
    type?: number;

    constructor(data?: ILadingBillCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LadingBillCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LadingBillCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["type"] = this.type;
        return data;
    }
}

export interface ILadingBillCreateDto {
    id?: number;
    code?: string | undefined;
    imageUrl?: string | undefined;
    documentIds?: number[] | undefined;
    type?: number;
}

export class LadingBillDetailDto implements ILadingBillDetailDto {
    id?: number;
    code?: string | undefined;
    imageUrl?: string | undefined;
    documents?: DocumentListShortDto[] | undefined;
    type?: number;

    constructor(data?: ILadingBillDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentListShortDto.fromJS(item));
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LadingBillDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new LadingBillDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["type"] = this.type;
        return data;
    }
}

export interface ILadingBillDetailDto {
    id?: number;
    code?: string | undefined;
    imageUrl?: string | undefined;
    documents?: DocumentListShortDto[] | undefined;
    type?: number;
}

export class ListActivityLogDto implements IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;

    constructor(data?: IListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
            this.createdName = _data["createdName"];
            this.createdAvatar = _data["createdAvatar"];
        }
    }

    static fromJS(data: any): ListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        data["createdName"] = this.createdName;
        data["createdAvatar"] = this.createdAvatar;
        return data;
    }
}

export interface IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;
}

export class ListChatGroupDto implements IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;

    constructor(data?: IListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            this.lastMessage = _data["lastMessage"];
            this.lastMessageDate = _data["lastMessageDate"] ? new Date(_data["lastMessageDate"].toString()) : <any>undefined;
            this.isOnline = _data["isOnline"];
            this.lastMessageType = _data["lastMessageType"];
            this.friendId = _data["friendId"];
            this.lastMessageId = _data["lastMessageId"];
            this.lastMessageIsRead = _data["lastMessageIsRead"];
        }
    }

    static fromJS(data: any): ListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        data["lastMessage"] = this.lastMessage;
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : <any>undefined;
        data["isOnline"] = this.isOnline;
        data["lastMessageType"] = this.lastMessageType;
        data["friendId"] = this.friendId;
        data["lastMessageId"] = this.lastMessageId;
        data["lastMessageIsRead"] = this.lastMessageIsRead;
        return data;
    }
}

export interface IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;
}

export class ListChatMessageByGroupDto implements IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;

    constructor(data?: IListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.senderId = _data["senderId"];
            this.chatGroupId = _data["chatGroupId"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderAvatar = _data["senderAvatar"];
            this.chatGroupName = _data["chatGroupName"];
            this.chatGroupAvatar = _data["chatGroupAvatar"];
            if (Array.isArray(_data["listFilePath"])) {
                this.listFilePath = [] as any;
                for (let item of _data["listFilePath"])
                    this.listFilePath!.push(item);
            }
            this.isOnline = _data["isOnline"];
            this.chatGroupType = _data["chatGroupType"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): ListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["senderId"] = this.senderId;
        data["chatGroupId"] = this.chatGroupId;
        data["content"] = this.content;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderAvatar"] = this.senderAvatar;
        data["chatGroupName"] = this.chatGroupName;
        data["chatGroupAvatar"] = this.chatGroupAvatar;
        if (Array.isArray(this.listFilePath)) {
            data["listFilePath"] = [];
            for (let item of this.listFilePath)
                data["listFilePath"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["chatGroupType"] = this.chatGroupType;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;
}

export class ListDocumentNotPaidDto implements IListDocumentNotPaidDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    originDocumentStatus?: number | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    totalAmount?: number;
    idCard?: string | undefined;

    constructor(data?: IListDocumentNotPaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fullName = _data["fullName"];
            this.originDocumentStatus = _data["originDocumentStatus"];
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.totalAmount = _data["totalAmount"];
            this.idCard = _data["idCard"];
        }
    }

    static fromJS(data: any): ListDocumentNotPaidDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListDocumentNotPaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fullName"] = this.fullName;
        data["originDocumentStatus"] = this.originDocumentStatus;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["totalAmount"] = this.totalAmount;
        data["idCard"] = this.idCard;
        return data;
    }
}

export interface IListDocumentNotPaidDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    originDocumentStatus?: number | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    totalAmount?: number;
    idCard?: string | undefined;
}

export class ListNotificationDto implements IListNotificationDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    action?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    objectTitle?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    appId?: number;
    isRead?: boolean;

    constructor(data?: IListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.action = _data["action"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.objectTitle = _data["objectTitle"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.url = _data["url"];
            this.appId = _data["appId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): ListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["action"] = this.action;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["objectTitle"] = this.objectTitle;
        data["title"] = this.title;
        data["message"] = this.message;
        data["url"] = this.url;
        data["appId"] = this.appId;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IListNotificationDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    action?: string | undefined;
    objectType?: string | undefined;
    objectId?: string | undefined;
    objectTitle?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
    appId?: number;
    isRead?: boolean;
}

export class ListPaymentForFacilityOrCompanyDto implements IListPaymentForFacilityOrCompanyDto {
    id?: number | undefined;
    name?: string | undefined;
    totalPaymentRequest?: number;
    totalPaymentRequestPaid?: number;
    totalPaymentRequestNotPaid?: number;
    totalAmountPaid?: number;
    totalAmountPaymentRequest?: number;
    totalAmountRemaining?: number;

    constructor(data?: IListPaymentForFacilityOrCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalPaymentRequest = _data["totalPaymentRequest"];
            this.totalPaymentRequestPaid = _data["totalPaymentRequestPaid"];
            this.totalPaymentRequestNotPaid = _data["totalPaymentRequestNotPaid"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.totalAmountPaymentRequest = _data["totalAmountPaymentRequest"];
            this.totalAmountRemaining = _data["totalAmountRemaining"];
        }
    }

    static fromJS(data: any): ListPaymentForFacilityOrCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPaymentForFacilityOrCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalPaymentRequest"] = this.totalPaymentRequest;
        data["totalPaymentRequestPaid"] = this.totalPaymentRequestPaid;
        data["totalPaymentRequestNotPaid"] = this.totalPaymentRequestNotPaid;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["totalAmountPaymentRequest"] = this.totalAmountPaymentRequest;
        data["totalAmountRemaining"] = this.totalAmountRemaining;
        return data;
    }
}

export interface IListPaymentForFacilityOrCompanyDto {
    id?: number | undefined;
    name?: string | undefined;
    totalPaymentRequest?: number;
    totalPaymentRequestPaid?: number;
    totalPaymentRequestNotPaid?: number;
    totalAmountPaid?: number;
    totalAmountPaymentRequest?: number;
    totalAmountRemaining?: number;
}

export class ListPaymentForFacilityOrCompanyFilterDto implements IListPaymentForFacilityOrCompanyFilterDto {
    id?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IListPaymentForFacilityOrCompanyFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.keyword = _data["keyword"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ListPaymentForFacilityOrCompanyFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListPaymentForFacilityOrCompanyFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["keyword"] = this.keyword;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IListPaymentForFacilityOrCompanyFilterDto {
    id?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class OriginalDocumentDto implements IOriginalDocumentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    status?: DocumentEnum;
    statuses?: LadingBillDocumentEntity[] | undefined;
    isCanSendType1?: boolean;
    isCanReceiveType1?: boolean;
    isCanSendType2?: boolean;
    isCanReceiveType2?: boolean;
    ladingBillId?: number;
    isPaid?: boolean;

    constructor(data?: IOriginalDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.fullName = _data["fullName"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.idCard = _data["idCard"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.status = _data["status"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(LadingBillDocumentEntity.fromJS(item));
            }
            this.isCanSendType1 = _data["isCanSendType1"];
            this.isCanReceiveType1 = _data["isCanReceiveType1"];
            this.isCanSendType2 = _data["isCanSendType2"];
            this.isCanReceiveType2 = _data["isCanReceiveType2"];
            this.ladingBillId = _data["ladingBillId"];
            this.isPaid = _data["isPaid"];
        }
    }

    static fromJS(data: any): OriginalDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["fullName"] = this.fullName;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["idCard"] = this.idCard;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["status"] = this.status;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        data["isCanSendType1"] = this.isCanSendType1;
        data["isCanReceiveType1"] = this.isCanReceiveType1;
        data["isCanSendType2"] = this.isCanSendType2;
        data["isCanReceiveType2"] = this.isCanReceiveType2;
        data["ladingBillId"] = this.ladingBillId;
        data["isPaid"] = this.isPaid;
        return data;
    }
}

export interface IOriginalDocumentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    status?: DocumentEnum;
    statuses?: LadingBillDocumentEntity[] | undefined;
    isCanSendType1?: boolean;
    isCanReceiveType1?: boolean;
    isCanSendType2?: boolean;
    isCanReceiveType2?: boolean;
    ladingBillId?: number;
    isPaid?: boolean;
}

export class OriginalDocumentListQueryDto implements IOriginalDocumentListQueryDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    keyword?: string | undefined;
    type?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    treatmentTypeId?: number | undefined;
    csytStatus?: number | undefined;
    status?: number | undefined;
    documentStatus?: number[] | undefined;

    constructor(data?: IOriginalDocumentListQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.code = _data["code"];
            this.keyword = _data["keyword"];
            this.type = _data["type"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.treatmentTypeId = _data["treatmentTypeId"];
            this.csytStatus = _data["csytStatus"];
            this.status = _data["status"];
            if (Array.isArray(_data["documentStatus"])) {
                this.documentStatus = [] as any;
                for (let item of _data["documentStatus"])
                    this.documentStatus!.push(item);
            }
        }
    }

    static fromJS(data: any): OriginalDocumentListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OriginalDocumentListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["code"] = this.code;
        data["keyword"] = this.keyword;
        data["type"] = this.type;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["treatmentTypeId"] = this.treatmentTypeId;
        data["csytStatus"] = this.csytStatus;
        data["status"] = this.status;
        if (Array.isArray(this.documentStatus)) {
            data["documentStatus"] = [];
            for (let item of this.documentStatus)
                data["documentStatus"].push(item);
        }
        return data;
    }
}

export interface IOriginalDocumentListQueryDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    code?: string | undefined;
    keyword?: string | undefined;
    type?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    customerId?: number | undefined;
    treatmentTypeId?: number | undefined;
    csytStatus?: number | undefined;
    status?: number | undefined;
    documentStatus?: number[] | undefined;
}

export class PaymentDocumentTimeQueryDto implements IPaymentDocumentTimeQueryDto {
    paymentRequestId?: number;
    documentIds?: number[] | undefined;

    constructor(data?: IPaymentDocumentTimeQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentRequestId = _data["paymentRequestId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentDocumentTimeQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDocumentTimeQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentRequestId"] = this.paymentRequestId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IPaymentDocumentTimeQueryDto {
    paymentRequestId?: number;
    documentIds?: number[] | undefined;
}

export class PaymentRequestCreateDto implements IPaymentRequestCreateDto {
    type?: number | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    documentIds?: number[] | undefined;

    constructor(data?: IPaymentRequestCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PaymentRequestCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IPaymentRequestCreateDto {
    type?: number | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    documentIds?: number[] | undefined;
}

export class PaymentRequestSummaryDto implements IPaymentRequestSummaryDto {
    totalDocument?: number;
    totalAmountPaid?: number;
    totalAmountRequest?: number;
    totalDiffirentAmountReqest?: number;
    totalAmountPayment?: number;
    totalDiffirentAmountPayment?: number;

    constructor(data?: IPaymentRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDocument = _data["totalDocument"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.totalAmountRequest = _data["totalAmountRequest"];
            this.totalDiffirentAmountReqest = _data["totalDiffirentAmountReqest"];
            this.totalAmountPayment = _data["totalAmountPayment"];
            this.totalDiffirentAmountPayment = _data["totalDiffirentAmountPayment"];
        }
    }

    static fromJS(data: any): PaymentRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDocument"] = this.totalDocument;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["totalAmountRequest"] = this.totalAmountRequest;
        data["totalDiffirentAmountReqest"] = this.totalDiffirentAmountReqest;
        data["totalAmountPayment"] = this.totalAmountPayment;
        data["totalDiffirentAmountPayment"] = this.totalDiffirentAmountPayment;
        return data;
    }
}

export interface IPaymentRequestSummaryDto {
    totalDocument?: number;
    totalAmountPaid?: number;
    totalAmountRequest?: number;
    totalDiffirentAmountReqest?: number;
    totalAmountPayment?: number;
    totalDiffirentAmountPayment?: number;
}

export class RenderPaymentPeriodDto implements IRenderPaymentPeriodDto {
    id?: number;
    fromDate?: Date;
    toDate?: Date;
    name?: string | undefined;

    constructor(data?: IRenderPaymentPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenderPaymentPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenderPaymentPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IRenderPaymentPeriodDto {
    id?: number;
    fromDate?: Date;
    toDate?: Date;
    name?: string | undefined;
}

export class RequestPaymentDetailDto implements IRequestPaymentDetailDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    status?: DocumentEnum;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    totalPayment?: number | undefined;
    amountPaid?: number | undefined;
    differenceAmount?: number;
    originDocumentStatus?: number;
    phone?: string | undefined;
    idCard?: string | undefined;
    paymentStatus?: number | undefined;

    constructor(data?: IRequestPaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fullName = _data["fullName"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.totalPayment = _data["totalPayment"];
            this.amountPaid = _data["amountPaid"];
            this.differenceAmount = _data["differenceAmount"];
            this.originDocumentStatus = _data["originDocumentStatus"];
            this.phone = _data["phone"];
            this.idCard = _data["idCard"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): RequestPaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fullName"] = this.fullName;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["totalPayment"] = this.totalPayment;
        data["amountPaid"] = this.amountPaid;
        data["differenceAmount"] = this.differenceAmount;
        data["originDocumentStatus"] = this.originDocumentStatus;
        data["phone"] = this.phone;
        data["idCard"] = this.idCard;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IRequestPaymentDetailDto {
    id?: number;
    code?: string | undefined;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    status?: DocumentEnum;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    totalPayment?: number | undefined;
    amountPaid?: number | undefined;
    differenceAmount?: number;
    originDocumentStatus?: number;
    phone?: string | undefined;
    idCard?: string | undefined;
    paymentStatus?: number | undefined;
}

export class RequestPaymentDto implements IRequestPaymentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    type?: number;
    totalAmountRequest?: number | undefined;
    confirmBy?: number | undefined;
    confirmDate?: Date | undefined;
    totalDocument?: number | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;
    confirmName?: string | undefined;
    confirmAvatar?: string | undefined;
    amountPaid?: number | undefined;
    diffirentAmount?: number | undefined;
    paymentDate?: Date | undefined;
    createdByType?: UserTypeEnum;

    constructor(data?: IRequestPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.totalAmountRequest = _data["totalAmountRequest"];
            this.confirmBy = _data["confirmBy"];
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : <any>undefined;
            this.totalDocument = _data["totalDocument"];
            this.createdName = _data["createdName"];
            this.createdAvatar = _data["createdAvatar"];
            this.confirmName = _data["confirmName"];
            this.confirmAvatar = _data["confirmAvatar"];
            this.amountPaid = _data["amountPaid"];
            this.diffirentAmount = _data["diffirentAmount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : <any>undefined;
            this.createdByType = _data["createdByType"];
        }
    }

    static fromJS(data: any): RequestPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["totalAmountRequest"] = this.totalAmountRequest;
        data["confirmBy"] = this.confirmBy;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : <any>undefined;
        data["totalDocument"] = this.totalDocument;
        data["createdName"] = this.createdName;
        data["createdAvatar"] = this.createdAvatar;
        data["confirmName"] = this.confirmName;
        data["confirmAvatar"] = this.confirmAvatar;
        data["amountPaid"] = this.amountPaid;
        data["diffirentAmount"] = this.diffirentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["createdByType"] = this.createdByType;
        return data;
    }
}

export interface IRequestPaymentDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    type?: number;
    totalAmountRequest?: number | undefined;
    confirmBy?: number | undefined;
    confirmDate?: Date | undefined;
    totalDocument?: number | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;
    confirmName?: string | undefined;
    confirmAvatar?: string | undefined;
    amountPaid?: number | undefined;
    diffirentAmount?: number | undefined;
    paymentDate?: Date | undefined;
    createdByType?: UserTypeEnum;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    listModule?: RoleModuleDto[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userCount = _data["userCount"];
            if (Array.isArray(_data["listModule"])) {
                this.listModule = [] as any;
                for (let item of _data["listModule"])
                    this.listModule!.push(RoleModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userCount"] = this.userCount;
        if (Array.isArray(this.listModule)) {
            data["listModule"] = [];
            for (let item of this.listModule)
                data["listModule"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    listModule?: RoleModuleDto[] | undefined;
}

export class RoleModuleDto implements IRoleModuleDto {
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isZone?: boolean;
    isFull?: boolean;
    tenantId?: number;
    permissions?: RolePermissionDto[] | undefined;

    constructor(data?: IRoleModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"];
            this.moduleName = _data["moduleName"];
            this.isZone = _data["isZone"];
            this.isFull = _data["isFull"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(RolePermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module;
        data["moduleName"] = this.moduleName;
        data["isZone"] = this.isZone;
        data["isFull"] = this.isFull;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleModuleDto {
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isZone?: boolean;
    isFull?: boolean;
    tenantId?: number;
    permissions?: RolePermissionDto[] | undefined;
}

export class RolePermissionDto implements IRolePermissionDto {
    fullZone?: boolean;
    zoneIds?: number[] | undefined;
    permission?: number;

    constructor(data?: IRolePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullZone = _data["fullZone"];
            if (Array.isArray(_data["zoneIds"])) {
                this.zoneIds = [] as any;
                for (let item of _data["zoneIds"])
                    this.zoneIds!.push(item);
            }
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): RolePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullZone"] = this.fullZone;
        if (Array.isArray(this.zoneIds)) {
            data["zoneIds"] = [];
            for (let item of this.zoneIds)
                data["zoneIds"].push(item);
        }
        data["permission"] = this.permission;
        return data;
    }
}

export interface IRolePermissionDto {
    fullZone?: boolean;
    zoneIds?: number[] | undefined;
    permission?: number;
}

export class TagAddNewsDto implements ITagAddNewsDto {
    tagId?: number;
    newsIds?: number[] | undefined;

    constructor(data?: ITagAddNewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            if (Array.isArray(_data["newsIds"])) {
                this.newsIds = [] as any;
                for (let item of _data["newsIds"])
                    this.newsIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TagAddNewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagAddNewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        if (Array.isArray(this.newsIds)) {
            data["newsIds"] = [];
            for (let item of this.newsIds)
                data["newsIds"].push(item);
        }
        return data;
    }
}

export interface ITagAddNewsDto {
    tagId?: number;
    newsIds?: number[] | undefined;
}

export class TagGetListQuery implements ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;

    constructor(data?: ITagGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TagGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["type"] = this.type;
        return data;
    }
}

export interface ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;
}

export class TagListDto implements ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;
    type?: number;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isHotTag = _data["isHotTag"];
            this.newsCount = _data["newsCount"];
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"];
            this.url = _data["url"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isHotTag"] = this.isHotTag;
        data["newsCount"] = this.newsCount;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone;
        data["url"] = this.url;
        data["type"] = this.type;
        return data;
    }
}

export interface ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;
    type?: number;
}

export class UserListDto implements IUserListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.roles = _data["roles"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["roles"] = this.roles;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IUserListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
}

export class UserReportCountDto implements IUserReportCountDto {
    countUser?: number;
    averageMonth?: number;
    averageDay?: number;
    timePerDocument?: number;

    constructor(data?: IUserReportCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countUser = _data["countUser"];
            this.averageMonth = _data["averageMonth"];
            this.averageDay = _data["averageDay"];
            this.timePerDocument = _data["timePerDocument"];
        }
    }

    static fromJS(data: any): UserReportCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countUser"] = this.countUser;
        data["averageMonth"] = this.averageMonth;
        data["averageDay"] = this.averageDay;
        data["timePerDocument"] = this.timePerDocument;
        return data;
    }
}

export interface IUserReportCountDto {
    countUser?: number;
    averageMonth?: number;
    averageDay?: number;
    timePerDocument?: number;
}

export class UserReportDto implements IUserReportDto {
    id?: number;
    fullName?: string | undefined;
    documentProcessed?: number;
    documentProcessing?: number;
    averageMonth?: number;
    averageDay?: number;
    timePerDocument?: number;
    documentProcessedPercent?: number;
    documentProcessingPercent?: number;
    averageMonthPercent?: number;
    averageDayPercent?: number;

    constructor(data?: IUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.documentProcessed = _data["documentProcessed"];
            this.documentProcessing = _data["documentProcessing"];
            this.averageMonth = _data["averageMonth"];
            this.averageDay = _data["averageDay"];
            this.timePerDocument = _data["timePerDocument"];
            this.documentProcessedPercent = _data["documentProcessedPercent"];
            this.documentProcessingPercent = _data["documentProcessingPercent"];
            this.averageMonthPercent = _data["averageMonthPercent"];
            this.averageDayPercent = _data["averageDayPercent"];
        }
    }

    static fromJS(data: any): UserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["documentProcessed"] = this.documentProcessed;
        data["documentProcessing"] = this.documentProcessing;
        data["averageMonth"] = this.averageMonth;
        data["averageDay"] = this.averageDay;
        data["timePerDocument"] = this.timePerDocument;
        data["documentProcessedPercent"] = this.documentProcessedPercent;
        data["documentProcessingPercent"] = this.documentProcessingPercent;
        data["averageMonthPercent"] = this.averageMonthPercent;
        data["averageDayPercent"] = this.averageDayPercent;
        return data;
    }
}

export interface IUserReportDto {
    id?: number;
    fullName?: string | undefined;
    documentProcessed?: number;
    documentProcessing?: number;
    averageMonth?: number;
    averageDay?: number;
    timePerDocument?: number;
    documentProcessedPercent?: number;
    documentProcessingPercent?: number;
    averageMonthPercent?: number;
    averageDayPercent?: number;
}

export class UserWithSimpleInfoDto implements IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;

    constructor(data?: IUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.type = _data["type"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): UserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;
}

export class ActivityLogEntity implements IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): ActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
}

export class FilterResult_1OfCategoryListDto implements IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;

    constructor(data?: IFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;
}

export class FilterResult_1OfContractListDto implements IFilterResult_1OfContractListDto {
    totalRows?: number;
    data?: ContractListDto[] | undefined;

    constructor(data?: IFilterResult_1OfContractListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ContractListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfContractListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfContractListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfContractListDto {
    totalRows?: number;
    data?: ContractListDto[] | undefined;
}

export class FilterResult_1OfDocumentListDto implements IFilterResult_1OfDocumentListDto {
    totalRows?: number;
    data?: DocumentListDto[] | undefined;

    constructor(data?: IFilterResult_1OfDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfDocumentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfDocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfDocumentListDto {
    totalRows?: number;
    data?: DocumentListDto[] | undefined;
}

export class FilterResult_1OfListActivityLogDto implements IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;

    constructor(data?: IFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListActivityLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;
}

export class FilterResult_1OfListChatGroupDto implements IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;
}

export class FilterResult_1OfListChatMessageByGroupDto implements IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatMessageByGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;
}

export class FilterResult_1OfListDocumentNotPaidDto implements IFilterResult_1OfListDocumentNotPaidDto {
    totalRows?: number;
    data?: ListDocumentNotPaidDto[] | undefined;

    constructor(data?: IFilterResult_1OfListDocumentNotPaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListDocumentNotPaidDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListDocumentNotPaidDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListDocumentNotPaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListDocumentNotPaidDto {
    totalRows?: number;
    data?: ListDocumentNotPaidDto[] | undefined;
}

export class FilterResult_1OfListNotificationDto implements IFilterResult_1OfListNotificationDto {
    totalRows?: number;
    data?: ListNotificationDto[] | undefined;

    constructor(data?: IFilterResult_1OfListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListNotificationDto {
    totalRows?: number;
    data?: ListNotificationDto[] | undefined;
}

export class FilterResult_1OfListPaymentForFacilityOrCompanyDto implements IFilterResult_1OfListPaymentForFacilityOrCompanyDto {
    totalRows?: number;
    data?: ListPaymentForFacilityOrCompanyDto[] | undefined;

    constructor(data?: IFilterResult_1OfListPaymentForFacilityOrCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListPaymentForFacilityOrCompanyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListPaymentForFacilityOrCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListPaymentForFacilityOrCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListPaymentForFacilityOrCompanyDto {
    totalRows?: number;
    data?: ListPaymentForFacilityOrCompanyDto[] | undefined;
}

export class FilterResult_1OfOriginalDocumentDto implements IFilterResult_1OfOriginalDocumentDto {
    totalRows?: number;
    data?: OriginalDocumentDto[] | undefined;

    constructor(data?: IFilterResult_1OfOriginalDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OriginalDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfOriginalDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfOriginalDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfOriginalDocumentDto {
    totalRows?: number;
    data?: OriginalDocumentDto[] | undefined;
}

export class FilterResult_1OfRequestPaymentDetailDto implements IFilterResult_1OfRequestPaymentDetailDto {
    totalRows?: number;
    data?: RequestPaymentDetailDto[] | undefined;

    constructor(data?: IFilterResult_1OfRequestPaymentDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequestPaymentDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfRequestPaymentDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfRequestPaymentDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfRequestPaymentDetailDto {
    totalRows?: number;
    data?: RequestPaymentDetailDto[] | undefined;
}

export class FilterResult_1OfRequestPaymentDto implements IFilterResult_1OfRequestPaymentDto {
    totalRows?: number;
    data?: RequestPaymentDto[] | undefined;

    constructor(data?: IFilterResult_1OfRequestPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequestPaymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfRequestPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfRequestPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfRequestPaymentDto {
    totalRows?: number;
    data?: RequestPaymentDto[] | undefined;
}

export class FilterResult_1OfTagListDto implements IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;
}

export class FilterResult_1OfUserListDto implements IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;
}

export class FilterResult_1OfUserReportDto implements IFilterResult_1OfUserReportDto {
    totalRows?: number;
    data?: UserReportDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfUserReportDto {
    totalRows?: number;
    data?: UserReportDto[] | undefined;
}

export class FilterResult_1OfFileEntity implements IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;

    constructor(data?: IFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;
}

export class FilterResult_1OfInsuranceCompanyEntity implements IFilterResult_1OfInsuranceCompanyEntity {
    totalRows?: number;
    data?: InsuranceCompanyEntity[] | undefined;

    constructor(data?: IFilterResult_1OfInsuranceCompanyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InsuranceCompanyEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfInsuranceCompanyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfInsuranceCompanyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfInsuranceCompanyEntity {
    totalRows?: number;
    data?: InsuranceCompanyEntity[] | undefined;
}

export class FilterResult_1OfLocalityEntity implements IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;

    constructor(data?: IFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;
}

export class FilterResult_1OfMedicalFacilityEntity implements IFilterResult_1OfMedicalFacilityEntity {
    totalRows?: number;
    data?: MedicalFacilityEntity[] | undefined;

    constructor(data?: IFilterResult_1OfMedicalFacilityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MedicalFacilityEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfMedicalFacilityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfMedicalFacilityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfMedicalFacilityEntity {
    totalRows?: number;
    data?: MedicalFacilityEntity[] | undefined;
}

export class CategoryEntity implements ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    itemCode?: string | undefined;
    weight?: number;
    value?: number;

    constructor(data?: ICategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.itemCode = _data["itemCode"];
            this.weight = _data["weight"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["itemCode"] = this.itemCode;
        data["weight"] = this.weight;
        data["value"] = this.value;
        return data;
    }
}

export interface ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    itemCode?: string | undefined;
    weight?: number;
    value?: number;
}

export class ChangeLogEntity implements IChangeLogEntity {
    id?: number;
    objectId?: number;
    objectType?: ModuleEnum;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdBy?: number;
    createdDate?: Date;

    constructor(data?: IChangeLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.fieldName = _data["fieldName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["fieldName"] = this.fieldName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangeLogEntity {
    id?: number;
    objectId?: number;
    objectType?: ModuleEnum;
    fieldName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdBy?: number;
    createdDate?: Date;
}

export class ChatGroupEntity implements IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;

    constructor(data?: IChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): ChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
}

export class ContractBenefitEntity implements IContractBenefitEntity {
    categoryId?: number;
    contractId?: number;
    amount?: number;

    constructor(data?: IContractBenefitEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.contractId = _data["contractId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ContractBenefitEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBenefitEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["contractId"] = this.contractId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IContractBenefitEntity {
    categoryId?: number;
    contractId?: number;
    amount?: number;
}

export class ContractEntity implements IContractEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    cnbhCertificateNumber?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    type?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number;
    data?: string | undefined;
    lossNotificationPeriod?: number;
    companyId?: number;
    benefit?: string | undefined;
    coverages?: string | undefined;
    processStatus?: number;
    filePath?: string | undefined;
    userId?: number;
    isPaid?: boolean;

    constructor(data?: IContractEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.cnbhCertificateNumber = _data["cnbhCertificateNumber"];
            this.insuredFullName = _data["insuredFullName"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.effectiveFromDate = _data["effectiveFromDate"] ? new Date(_data["effectiveFromDate"].toString()) : <any>undefined;
            this.effectiveToDate = _data["effectiveToDate"] ? new Date(_data["effectiveToDate"].toString()) : <any>undefined;
            this.fee = _data["fee"];
            this.data = _data["data"];
            this.lossNotificationPeriod = _data["lossNotificationPeriod"];
            this.companyId = _data["companyId"];
            this.benefit = _data["benefit"];
            this.coverages = _data["coverages"];
            this.processStatus = _data["processStatus"];
            this.filePath = _data["filePath"];
            this.userId = _data["userId"];
            this.isPaid = _data["isPaid"];
        }
    }

    static fromJS(data: any): ContractEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ContractEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["cnbhCertificateNumber"] = this.cnbhCertificateNumber;
        data["insuredFullName"] = this.insuredFullName;
        data["identityCardNumber"] = this.identityCardNumber;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["type"] = this.type;
        data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : <any>undefined;
        data["effectiveToDate"] = this.effectiveToDate ? this.effectiveToDate.toISOString() : <any>undefined;
        data["fee"] = this.fee;
        data["data"] = this.data;
        data["lossNotificationPeriod"] = this.lossNotificationPeriod;
        data["companyId"] = this.companyId;
        data["benefit"] = this.benefit;
        data["coverages"] = this.coverages;
        data["processStatus"] = this.processStatus;
        data["filePath"] = this.filePath;
        data["userId"] = this.userId;
        data["isPaid"] = this.isPaid;
        return data;
    }
}

export interface IContractEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    cnbhCertificateNumber?: string | undefined;
    insuredFullName?: string | undefined;
    identityCardNumber?: string | undefined;
    dateOfBirth?: Date | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    type?: number;
    effectiveFromDate?: Date | undefined;
    effectiveToDate?: Date | undefined;
    fee?: number;
    data?: string | undefined;
    lossNotificationPeriod?: number;
    companyId?: number;
    benefit?: string | undefined;
    coverages?: string | undefined;
    processStatus?: number;
    filePath?: string | undefined;
    userId?: number;
    isPaid?: boolean;
}

export class DocumentEntity implements IDocumentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;

    constructor(data?: IDocumentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.customerId = _data["customerId"];
            this.contractId = _data["contractId"];
            this.contractCode = _data["contractCode"];
            this.processedBy = _data["processedBy"];
            this.status = _data["status"];
            this.oldStatus = _data["oldStatus"];
            this.fullName = _data["fullName"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.idCard = _data["idCard"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.workUnit = _data["workUnit"];
            this.cardNumber = _data["cardNumber"];
            this.cardName = _data["cardName"];
            this.cardType = _data["cardType"];
            this.cardValidity = _data["cardValidity"] ? new Date(_data["cardValidity"].toString()) : <any>undefined;
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.treatmentType = _data["treatmentType"];
            this.diseaseType = _data["diseaseType"];
            this.rejectionType = _data["rejectionType"];
            this.diagnosis = _data["diagnosis"];
            this.daysInHospital = _data["daysInHospital"];
            this.insuranceBenefits = _data["insuranceBenefits"];
            this.paymentInfo = _data["paymentInfo"];
            this.totalPayment = _data["totalPayment"];
            this.totalCost = _data["totalCost"];
            this.totalAmount = _data["totalAmount"];
            this.paidByPatient = _data["paidByPatient"];
            this.paidByInsurance = _data["paidByInsurance"];
            this.isPaid = _data["isPaid"];
            this.tpaBy = _data["tpaBy"];
            this.tpaReceiveDate = _data["tpaReceiveDate"] ? new Date(_data["tpaReceiveDate"].toString()) : <any>undefined;
            this.processingTime = _data["processingTime"];
            this.sessionTime = _data["sessionTime"] ? new Date(_data["sessionTime"].toString()) : <any>undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.summary = _data["summary"];
            this.missingFile = _data["missingFile"];
            this.priority = _data["priority"];
            this.extractBy = _data["extractBy"];
            this.extractDate = _data["extractDate"] ? new Date(_data["extractDate"].toString()) : <any>undefined;
            this.medicalBy = _data["medicalBy"];
            this.medicalDate = _data["medicalDate"] ? new Date(_data["medicalDate"].toString()) : <any>undefined;
            this.idusProcessed = _data["idusProcessed"];
            this.note = _data["note"];
            this.isMappingContract = _data["isMappingContract"];
            this.mappingContractData = _data["mappingContractData"];
            this.benefitGroup = _data["benefitGroup"];
        }
    }

    static fromJS(data: any): DocumentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["customerId"] = this.customerId;
        data["contractId"] = this.contractId;
        data["contractCode"] = this.contractCode;
        data["processedBy"] = this.processedBy;
        data["status"] = this.status;
        data["oldStatus"] = this.oldStatus;
        data["fullName"] = this.fullName;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["idCard"] = this.idCard;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["workUnit"] = this.workUnit;
        data["cardNumber"] = this.cardNumber;
        data["cardName"] = this.cardName;
        data["cardType"] = this.cardType;
        data["cardValidity"] = this.cardValidity ? this.cardValidity.toISOString() : <any>undefined;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["treatmentType"] = this.treatmentType;
        data["diseaseType"] = this.diseaseType;
        data["rejectionType"] = this.rejectionType;
        data["diagnosis"] = this.diagnosis;
        data["daysInHospital"] = this.daysInHospital;
        data["insuranceBenefits"] = this.insuranceBenefits;
        data["paymentInfo"] = this.paymentInfo;
        data["totalPayment"] = this.totalPayment;
        data["totalCost"] = this.totalCost;
        data["totalAmount"] = this.totalAmount;
        data["paidByPatient"] = this.paidByPatient;
        data["paidByInsurance"] = this.paidByInsurance;
        data["isPaid"] = this.isPaid;
        data["tpaBy"] = this.tpaBy;
        data["tpaReceiveDate"] = this.tpaReceiveDate ? this.tpaReceiveDate.toISOString() : <any>undefined;
        data["processingTime"] = this.processingTime;
        data["sessionTime"] = this.sessionTime ? this.sessionTime.toISOString() : <any>undefined;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["summary"] = this.summary;
        data["missingFile"] = this.missingFile;
        data["priority"] = this.priority;
        data["extractBy"] = this.extractBy;
        data["extractDate"] = this.extractDate ? this.extractDate.toISOString() : <any>undefined;
        data["medicalBy"] = this.medicalBy;
        data["medicalDate"] = this.medicalDate ? this.medicalDate.toISOString() : <any>undefined;
        data["idusProcessed"] = this.idusProcessed;
        data["note"] = this.note;
        data["isMappingContract"] = this.isMappingContract;
        data["mappingContractData"] = this.mappingContractData;
        data["benefitGroup"] = this.benefitGroup;
        return data;
    }
}

export interface IDocumentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number;
    companyId?: number | undefined;
    customerId?: number | undefined;
    contractId?: number | undefined;
    contractCode?: string | undefined;
    processedBy?: number;
    status?: DocumentEnum;
    oldStatus?: DocumentEnum;
    fullName?: string | undefined;
    birthDay?: Date | undefined;
    idCard?: string | undefined;
    gender?: number;
    phone?: string | undefined;
    email?: string | undefined;
    workUnit?: string | undefined;
    cardNumber?: string | undefined;
    cardName?: string | undefined;
    cardType?: string | undefined;
    cardValidity?: Date | undefined;
    admissionDate?: Date | undefined;
    dischargeDate?: Date | undefined;
    treatmentType?: number | undefined;
    diseaseType?: number | undefined;
    rejectionType?: number | undefined;
    diagnosis?: string | undefined;
    daysInHospital?: number | undefined;
    insuranceBenefits?: string | undefined;
    paymentInfo?: string | undefined;
    totalPayment?: number | undefined;
    totalCost?: number | undefined;
    totalAmount?: number;
    paidByPatient?: number | undefined;
    paidByInsurance?: number | undefined;
    isPaid?: boolean;
    tpaBy?: number;
    tpaReceiveDate?: Date;
    processingTime?: number;
    sessionTime?: Date | undefined;
    approvalDate?: Date | undefined;
    summary?: string | undefined;
    missingFile?: string | undefined;
    priority?: number;
    extractBy?: number;
    extractDate?: Date | undefined;
    medicalBy?: number | undefined;
    medicalDate?: Date | undefined;
    idusProcessed?: boolean;
    note?: string | undefined;
    isMappingContract?: boolean;
    mappingContractData?: string | undefined;
    benefitGroup?: number | undefined;
}

export class DocumentFileEntity implements IDocumentFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    documentId?: number;
    formType?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    totalPage?: number;
    originalFile?: boolean;
    sessionDate?: Date;
    extractInfo?: string | undefined;
    originalFileId?: number;

    constructor(data?: IDocumentFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.documentId = _data["documentId"];
            this.formType = _data["formType"];
            this.fileName = _data["fileName"];
            this.url = _data["url"];
            this.totalPage = _data["totalPage"];
            this.originalFile = _data["originalFile"];
            this.sessionDate = _data["sessionDate"] ? new Date(_data["sessionDate"].toString()) : <any>undefined;
            this.extractInfo = _data["extractInfo"];
            this.originalFileId = _data["originalFileId"];
        }
    }

    static fromJS(data: any): DocumentFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["documentId"] = this.documentId;
        data["formType"] = this.formType;
        data["fileName"] = this.fileName;
        data["url"] = this.url;
        data["totalPage"] = this.totalPage;
        data["originalFile"] = this.originalFile;
        data["sessionDate"] = this.sessionDate ? this.sessionDate.toISOString() : <any>undefined;
        data["extractInfo"] = this.extractInfo;
        data["originalFileId"] = this.originalFileId;
        return data;
    }
}

export interface IDocumentFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    documentId?: number;
    formType?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    totalPage?: number;
    originalFile?: boolean;
    sessionDate?: Date;
    extractInfo?: string | undefined;
    originalFileId?: number;
}

export class DocumentFilePartEntity implements IDocumentFilePartEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    documentFileId?: number;
    documentId?: number;
    page?: number;
    url?: string | undefined;
    idusUrl?: string | undefined;
    idusData?: string | undefined;
    brushes?: string | undefined;
    processed?: number;
    width?: number;
    height?: number;

    constructor(data?: IDocumentFilePartEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.documentFileId = _data["documentFileId"];
            this.documentId = _data["documentId"];
            this.page = _data["page"];
            this.url = _data["url"];
            this.idusUrl = _data["idusUrl"];
            this.idusData = _data["idusData"];
            this.brushes = _data["brushes"];
            this.processed = _data["processed"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): DocumentFilePartEntity {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentFilePartEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["documentFileId"] = this.documentFileId;
        data["documentId"] = this.documentId;
        data["page"] = this.page;
        data["url"] = this.url;
        data["idusUrl"] = this.idusUrl;
        data["idusData"] = this.idusData;
        data["brushes"] = this.brushes;
        data["processed"] = this.processed;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IDocumentFilePartEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    documentFileId?: number;
    documentId?: number;
    page?: number;
    url?: string | undefined;
    idusUrl?: string | undefined;
    idusData?: string | undefined;
    brushes?: string | undefined;
    processed?: number;
    width?: number;
    height?: number;
}

export class FileEntity implements IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;

    constructor(data?: IFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.contentType = _data["contentType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.size = _data["size"];
            this.extension = _data["extension"];
            this.folderId = _data["folderId"];
            this.status = _data["status"];
            this.avatar = _data["avatar"];
            this.thumbnails = _data["thumbnails"];
            this.streamUrl = _data["streamUrl"];
            this.duration = _data["duration"];
            this.fileType = _data["fileType"];
            this.objectType = _data["objectType"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["metaDatas"])) {
                this.metaDatas = [] as any;
                for (let item of _data["metaDatas"])
                    this.metaDatas!.push(FileMetaDataEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["path"] = this.path;
        data["contentType"] = this.contentType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["size"] = this.size;
        data["extension"] = this.extension;
        data["folderId"] = this.folderId;
        data["status"] = this.status;
        data["avatar"] = this.avatar;
        data["thumbnails"] = this.thumbnails;
        data["streamUrl"] = this.streamUrl;
        data["duration"] = this.duration;
        data["fileType"] = this.fileType;
        data["objectType"] = this.objectType;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.metaDatas)) {
            data["metaDatas"] = [];
            for (let item of this.metaDatas)
                data["metaDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;
}

export class FileMetaDataEntity implements IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;

    constructor(data?: IFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.fileId = _data["fileId"];
            this.metaDirectory = _data["metaDirectory"];
            this.metaKey = _data["metaKey"];
            this.metaValue = _data["metaValue"];
        }
    }

    static fromJS(data: any): FileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["fileId"] = this.fileId;
        data["metaDirectory"] = this.metaDirectory;
        data["metaKey"] = this.metaKey;
        data["metaValue"] = this.metaValue;
        return data;
    }
}

export interface IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;
}

export class FolderEntity implements IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;
}

export class InsuranceCompanyEntity implements IInsuranceCompanyEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    shortName?: string | undefined;
    fullName?: string | undefined;
    logo?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    maximumPayment?: number;
    showLimitPayment?: boolean | undefined;
    maximumFundAmount?: number;
    minimumFundAmount?: number;
    paymentPeriod?: number | undefined;
    paymentTime?: number | undefined;
    contractEffectiveDate?: Date;
    status?: InsuranceCompanyEnum;

    constructor(data?: IInsuranceCompanyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.shortName = _data["shortName"];
            this.fullName = _data["fullName"];
            this.logo = _data["logo"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.maximumPayment = _data["maximumPayment"];
            this.showLimitPayment = _data["showLimitPayment"];
            this.maximumFundAmount = _data["maximumFundAmount"];
            this.minimumFundAmount = _data["minimumFundAmount"];
            this.paymentPeriod = _data["paymentPeriod"];
            this.paymentTime = _data["paymentTime"];
            this.contractEffectiveDate = _data["contractEffectiveDate"] ? new Date(_data["contractEffectiveDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InsuranceCompanyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["shortName"] = this.shortName;
        data["fullName"] = this.fullName;
        data["logo"] = this.logo;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["maximumPayment"] = this.maximumPayment;
        data["showLimitPayment"] = this.showLimitPayment;
        data["maximumFundAmount"] = this.maximumFundAmount;
        data["minimumFundAmount"] = this.minimumFundAmount;
        data["paymentPeriod"] = this.paymentPeriod;
        data["paymentTime"] = this.paymentTime;
        data["contractEffectiveDate"] = this.contractEffectiveDate ? this.contractEffectiveDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IInsuranceCompanyEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    shortName?: string | undefined;
    fullName?: string | undefined;
    logo?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    maximumPayment?: number;
    showLimitPayment?: boolean | undefined;
    maximumFundAmount?: number;
    minimumFundAmount?: number;
    paymentPeriod?: number | undefined;
    paymentTime?: number | undefined;
    contractEffectiveDate?: Date;
    status?: InsuranceCompanyEnum;
}

export class LadingBillDocumentEntity implements ILadingBillDocumentEntity {
    ladingBillId?: number;
    documentId?: number;
    sendDate?: Date | undefined;
    reciveDate?: Date | undefined;
    status?: number;
    type?: number;
    isActive?: boolean;

    constructor(data?: ILadingBillDocumentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ladingBillId = _data["ladingBillId"];
            this.documentId = _data["documentId"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.reciveDate = _data["reciveDate"] ? new Date(_data["reciveDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): LadingBillDocumentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LadingBillDocumentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ladingBillId"] = this.ladingBillId;
        data["documentId"] = this.documentId;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["reciveDate"] = this.reciveDate ? this.reciveDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ILadingBillDocumentEntity {
    ladingBillId?: number;
    documentId?: number;
    sendDate?: Date | undefined;
    reciveDate?: Date | undefined;
    status?: number;
    type?: number;
    isActive?: boolean;
}

export class LocalityEntity implements ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;

    constructor(data?: ILocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.otherName = _data["otherName"];
            this.url = _data["url"];
            this.unitType = _data["unitType"];
            this.parentId = _data["parentId"];
            this.priority = _data["priority"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["otherName"] = this.otherName;
        data["url"] = this.url;
        data["unitType"] = this.unitType;
        data["parentId"] = this.parentId;
        data["priority"] = this.priority;
        data["type"] = this.type;
        return data;
    }
}

export interface ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
}

export enum LocalityTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class MedicalFacilityEntity implements IMedicalFacilityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    province?: number;
    district?: number;
    ward?: number;
    guaranteeTime?: string | undefined;
    scopeOfGuarantee?: number;
    bankAccountNumber?: string | undefined;
    bankAccountName?: string | undefined;
    bankName?: string | undefined;
    contact?: string | undefined;
    contactAccounting?: string | undefined;
    note?: string | undefined;
    paymentPeriod?: number | undefined;
    paymentTime?: number | undefined;
    contractEffectiveDate?: Date;
    contractExpiryDate?: Date;
    status?: MedicalFacilityEnum;
    type?: MedicalFacilityTypeEnum;

    constructor(data?: IMedicalFacilityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.phone = _data["phone"];
            this.province = _data["province"];
            this.district = _data["district"];
            this.ward = _data["ward"];
            this.guaranteeTime = _data["guaranteeTime"];
            this.scopeOfGuarantee = _data["scopeOfGuarantee"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankAccountName = _data["bankAccountName"];
            this.bankName = _data["bankName"];
            this.contact = _data["contact"];
            this.contactAccounting = _data["contactAccounting"];
            this.note = _data["note"];
            this.paymentPeriod = _data["paymentPeriod"];
            this.paymentTime = _data["paymentTime"];
            this.contractEffectiveDate = _data["contractEffectiveDate"] ? new Date(_data["contractEffectiveDate"].toString()) : <any>undefined;
            this.contractExpiryDate = _data["contractExpiryDate"] ? new Date(_data["contractExpiryDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MedicalFacilityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalFacilityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        data["guaranteeTime"] = this.guaranteeTime;
        data["scopeOfGuarantee"] = this.scopeOfGuarantee;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankAccountName"] = this.bankAccountName;
        data["bankName"] = this.bankName;
        data["contact"] = this.contact;
        data["contactAccounting"] = this.contactAccounting;
        data["note"] = this.note;
        data["paymentPeriod"] = this.paymentPeriod;
        data["paymentTime"] = this.paymentTime;
        data["contractEffectiveDate"] = this.contractEffectiveDate ? this.contractEffectiveDate.toISOString() : <any>undefined;
        data["contractExpiryDate"] = this.contractExpiryDate ? this.contractExpiryDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IMedicalFacilityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    phone?: string | undefined;
    province?: number;
    district?: number;
    ward?: number;
    guaranteeTime?: string | undefined;
    scopeOfGuarantee?: number;
    bankAccountNumber?: string | undefined;
    bankAccountName?: string | undefined;
    bankName?: string | undefined;
    contact?: string | undefined;
    contactAccounting?: string | undefined;
    note?: string | undefined;
    paymentPeriod?: number | undefined;
    paymentTime?: number | undefined;
    contractEffectiveDate?: Date;
    contractExpiryDate?: Date;
    status?: MedicalFacilityEnum;
    type?: MedicalFacilityTypeEnum;
}

export class UserMobileTokenEntity implements IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;

    constructor(data?: IUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.deviceToken = _data["deviceToken"];
            this.os = _data["os"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["deviceToken"] = this.deviceToken;
        data["os"] = this.os;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;
}

export class UserWebTokenEntity implements IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;

    constructor(data?: IUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.pushEndPoint = _data["pushEndPoint"];
            this.pushP256DH = _data["pushP256DH"];
            this.pushAuth = _data["pushAuth"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["pushEndPoint"] = this.pushEndPoint;
        data["pushP256DH"] = this.pushP256DH;
        data["pushAuth"] = this.pushAuth;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;
}

export class PaymentRequestEntity implements IPaymentRequestEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    type?: number;
    totalAmountRequest?: number | undefined;
    confirmBy?: number | undefined;
    confirmDate?: Date | undefined;

    constructor(data?: IPaymentRequestEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.facilityId = _data["facilityId"];
            this.companyId = _data["companyId"];
            this.type = _data["type"];
            this.totalAmountRequest = _data["totalAmountRequest"];
            this.confirmBy = _data["confirmBy"];
            this.confirmDate = _data["confirmDate"] ? new Date(_data["confirmDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentRequestEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["facilityId"] = this.facilityId;
        data["companyId"] = this.companyId;
        data["type"] = this.type;
        data["totalAmountRequest"] = this.totalAmountRequest;
        data["confirmBy"] = this.confirmBy;
        data["confirmDate"] = this.confirmDate ? this.confirmDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPaymentRequestEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    facilityId?: number | undefined;
    companyId?: number | undefined;
    type?: number;
    totalAmountRequest?: number | undefined;
    confirmBy?: number | undefined;
    confirmDate?: Date | undefined;
}

export enum FileStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class Enum implements IEnum {

    constructor(data?: IEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Enum {
        data = typeof data === 'object' ? data : {};
        let result = new Enum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEnum {
}

export class VapidDetails implements IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;

    constructor(data?: IVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.publicKey = _data["publicKey"];
            this.privateKey = _data["privateKey"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any): VapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["publicKey"] = this.publicKey;
        data["privateKey"] = this.privateKey;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class BearException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isBearException = true;

    static isBearException(obj: any): obj is BearException {
        return obj.isBearException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new BearException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}